import $ from 'jquery';
//import CogAdapter from 'cog-adapter/src/components/mapview.js';
import { GET_DW_ENTITY_CONTACT, GET_DW_ENTITY_ADDRESSES } from '../queries';
import {fromLonLat, transformExtent} from 'ol/proj.js';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import VectorSource from 'ol/source/Vector.js';
import {Image as ImageLayer, Tile as TileLayer, Vector as VectorLayer, /*VectorTile as VectorTileLayer,*/ Group as LayerGroup} from 'ol/layer.js';
import XYZ from 'ol/source/XYZ.js';
import 'ol/ol.css';
import MVT from 'ol/format/MVT';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import ImageWMS from 'ol/source/ImageWMS.js';
import {defaults as defaultControls, Control} from 'ol/control.js';
import {/*inherits,*/ Overlay, Feature} from 'ol';
import {unByKey} from 'ol/Observable';
import {getLength, getArea} from 'ol/sphere.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import WebGLTileLayer from 'ol/layer/WebGLTile';
import OSM from 'ol/source/OSM';
import GeoTIFFSource from 'ol/source/GeoTIFF';
import {Style, Fill, Stroke, Circle, Text, Icon} from 'ol/style.js';
import {Select, Modify, Snap, Draw, DragBox} from 'ol/interaction.js';
import {altKeyOnly} from 'ol/events/condition.js';
import Polygon from 'ol/geom/Polygon.js';
import {fromExtent} from 'ol/geom/Polygon.js';
import LineString from 'ol/geom/LineString.js';
//import Projection from 'ol/proj/Projection.js';
//import VectorTileSource from 'ol/source/VectorTile.js';
import {fetchJwtToken} from "../utils";
//import geojsonvt from 'geojson-vt';
import jsPDF from 'jspdf';
import 'html-to-image';
import Vector from 'ol/source/Vector.js';
import WebGLPointsLayer from 'ol/layer/WebGLPoints.js';
import Point from 'ol/geom/Point.js';
import { isStats, isProperty } from '../data/utils';
import { colorStyleToWebGlStyle, colorStyleToGeoJSONStyle, getArrayMin, mapColorScaleDomain, scales } from '../colorscaleUtils';
import _ from 'lodash';
import moment from 'moment';

var inherits = function(child:any,parent:any) {
  child.prototype = Object.create(parent.prototype);
  child.prototype.constructor = child;
};

// Threshold for cross over from lower-res mosaic to full-res tiles
const zoomLevelCrossover = 14;
const zoomLevelCrossoverNaip = 10;

const pointRadius = 3;
var infoOverlay:any;
var dwPointOverlay:any;
var dwFieldOverlay:any;
var genericPointOverlay:any;
var activeTool = '';  // e.g., 'aoi edit', 'measure'
// https://stackoverflow.com/questions/3885817/how-do-i-check-that-a-number-is-float-or-integer
function isFloat(n: any){
  return Number(n) === n && n % 1 !== 0;
}

/*
const isDefined = (val: any) => {
  return val || val === 0 || val === 0.0;
};
*/

// note, naming this function "useMapExtent" causes react-hooks error
function doUseMapExtent(map: any, socket: any, aoiVectorLayer: any, updateAOIQuery:any) {
  map.removeInteraction(select);
  select.getFeatures().clear();
  activeAOIModification = false;
  map.removeInteraction(modify);
  map.removeInteraction(snap);

  const mapView = map.getView();
  var extent = mapView.calculateExtent(map.getSize());

  var polygon = fromExtent(extent);

  // Create feature with polygon.
  var feature = new Feature(polygon);
  var vectorSource = new VectorSource();

  vectorSource.addFeature(feature);
  aoiVectorLayer.setSource(vectorSource);

  mapView.fit(vectorSource.getExtent());

  var bbox = transformExtent(extent,'EPSG:3857','EPSG:4326');

  map['aoi_bbox'] = bbox;

  socket.emit('map', {
    command: 'setAOI',
    data: bbox
  });

  // Turn on edit AOI button after AOI is set from map extent (for instances where no AOI didn't yet exist)
  var editAOIIcon = document.querySelector('.edit-aoi-icon')
  var editAOIButton = document.querySelector('.edit-aoi-button')
  if (editAOIIcon &&  editAOIButton){ // avoid "Object is possibly 'null'." error 
      editAOIButton.classList.remove('edit-aoi-button-toggle-hidden');
      editAOIIcon.classList.remove('fa-save');
      editAOIIcon.classList.add('fa-vector-square');
  }  
  // Turn on delete AOI button after AOI is set from map extent
  var deleteAOIButton = document.querySelector('.delete-aoi-button')
  if (deleteAOIButton){ // avoid "Object is possibly 'null'." error 
      deleteAOIButton.classList.remove('delete-aoi-button-toggle-hidden');
  }
  updateAOIQuery("Updated from MapInit > doUseMapExtent")
}

// Delete the AOI
function doClearAOI(map: any, socket: any, aoiVectorLayer: any, _caller:string, updateAOIQuery:any) {
 
  map.removeInteraction(select);
  select.getFeatures().clear();
  activeAOIModification = false;
  map.removeInteraction(modify);
  map.removeInteraction(snap);


  // Create feature with nothing inside.
  var feature = new Feature();
  var vectorSource = new VectorSource();

  vectorSource.addFeature(feature);
  aoiVectorLayer.setSource(vectorSource);

  // Turn on edit AOI button after AOI is set from map extent (for instances where no AOI didn't yet exist)
  var editAOIIcon = document.querySelector('.edit-aoi-icon')
  var editAOIButton = document.querySelector('.edit-aoi-button')
  var deleteAOIButton = document.querySelector('.delete-aoi-button')
  if (editAOIIcon &&  editAOIButton && deleteAOIButton){ // avoid "Object is possibly 'null'." error 
      editAOIButton.classList.add('edit-aoi-button-toggle-hidden');
      deleteAOIButton.classList.add('delete-aoi-button-toggle-hidden');
      editAOIIcon.classList.remove('fa-save');
      editAOIIcon.classList.add('fa-vector-square');
  }
  if (activeTool === 'aoi edit') {
    activeTool = '';
  }

  map['aoi_bbox'] = null;

  // Dont emit to others unless you were the initiator (i.e., your screen pressed the button) 
  if (_caller === "button"){ 
    socket.emit('map', {
      command: 'clearAOI',
      data: null
    });    
  }
  updateAOIQuery("mapInit.ts > doClearAOI")
}

// Toggle the editability of AOI
function doEditMap (_select: any, _modify:any, _snap: any, _map: any, _aoiVectorLayer: any, _socket: any, updateAOIQuery:any) {
  console.log("doEditMap")
  var editAOIIcon = document.querySelector('.edit-aoi-icon')
  if ((activeTool !== 'aoi edit') && (activeTool !== '')) { // If AOI is not already in edit mode and no tool is active then clear all tools.
    resetTools("aoi edit", activeTool)
  }
  if (editAOIIcon){ // avoid "Object is possibly 'null'." error 
    if (editAOIIcon.classList.contains('fa-vector-square')){ // if the button is in edit "on" mode --> Begin AOI edit session
      _map.addInteraction(_select);
      _map.addInteraction(_modify);
      _map.addInteraction(_snap);
      editAOIIcon.classList.remove('fa-vector-square');
      editAOIIcon.classList.add('fa-save');
      activeTool = 'aoi edit'
    } else {                                                // if the button is in edit "off" mode --> Save edits and end AOI edit session   
      editAOIIcon.classList.remove('fa-save');
      editAOIIcon.classList.add('fa-vector-square');
      activeTool = ''
      doSaveMap (_select, _modify, _snap, _map, _aoiVectorLayer, _socket, updateAOIQuery)
    }
  }
}

function doSaveMap (_select: any, _modify:any, _snap: any, _map: any, _aoiVectorLayer: any, _socket: any, updateAOIQuery:any) {
  _map.removeInteraction(_select);
  _select.getFeatures().clear();
  activeAOIModification = false;
  _map.removeInteraction(_modify);
  _map.removeInteraction(_snap);

  // Save the extent of the user-defined AOI (_aoiVectorLayer) for now. We may support non-rectangular AOI later.
  var _coords = _aoiVectorLayer.getSource().getExtent() 

  var newBbox = transformExtent(_coords,'EPSG:3857','EPSG:4326');

  _map['aoi_bbox'] = newBbox;

  _socket.emit('map', {
    command: 'setAOI',
    data: newBbox
  });
  updateAOIQuery("mapinit.ts > doSaveMap")
}

function resetTools(_caller:string, _activeTool:string){
  switch(_activeTool) {
    case 'measure':
      // Turn off measure tool
      console.log("Measure tool is on! Turning it off for you.");
      clickButtonByParent(".measure-tool")
      break;
    case 'aoi edit':
      // Turn off AOI edit tool
      console.log("AOI Edit tool is on! Turning it off for you.");
      clickButtonByParent(".edit-aoi-button")
      break;
    /*case 'image info':
      // Turn off image info (i) tool
      console.log("Image info tool is on! Turning it off for you.");
      clickButtonByParent(".edit-aoi-button")
      break;*/
    default:
      console.log('No reset tools action needed.');
      break;
  }
}

// Helper function, to select and programmatically click a button. 
function clickButtonByParent(_parent:String){ // _parent = the unque class of the element containing the button 
  let buttonToClickParent: HTMLElement = document.querySelector("" + _parent) as HTMLElement;
  if (buttonToClickParent.localName === "button"){ // Button may be nested in a parent
    buttonToClickParent.click();
  }else{
    let buttonToClick: HTMLElement = buttonToClickParent.querySelector("button") as HTMLElement;
    buttonToClick.click();
  }
}

var handleMapPrintClick = function(_printType:String, _map:any, _caller:String) {
  var size = _map.getSize(); 
  if (_printType === "pdf"){
      // Adapted from: https://openlayers.org/en/latest/examples/export-pdf.html
      document.body.style.cursor = 'progress';
      // var format:any = 'a1'; //document.getElementById('format').value;
      var resolution = 150; //document.getElementById('resolution').value;
      
      var dim = [size[0], size[1]]; //dims[format];
      var calibration = 25.4;
      var width = Math.round(dim[0] * resolution / calibration);
      var height = Math.round(dim[1] * resolution / calibration);
      var viewResolution = _map.getView().getResolution();
      _map.once('rendercomplete', function() {
        var mapCanvas = document.createElement('canvas');
        mapCanvas.width = width;
        mapCanvas.height = height;
        var mapContext: CanvasRenderingContext2D = mapCanvas.getContext('2d') as CanvasRenderingContext2D;
        Array.prototype.forEach.call(document.querySelectorAll('canvas'), function(canvas) {
          if (canvas.width > 0) {
            var opacity = canvas.parentNode.style.opacity;
            mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
            var transform = canvas.style.transform;
            if (transform !== ""){
              // Get the transform parameters from the style's transform matrix
              var matrix = transform.match(/^matrix\(([^(]*)\)$/)[1].split(',').map(Number);
              // Apply the transform to the export map context
              CanvasRenderingContext2D.prototype.setTransform.apply(mapContext, matrix);
            }
            mapContext.drawImage(canvas, 0, 0);
          }
        });
        var layout:String = 'portrait';
        if (height < width){
          layout = 'landscape'
        }
        var pdf = new jsPDF(/*{
          orientation: layout,
          unit: 'px',
          format: [height, width]
        }*/);
        var widthPDF = pdf.internal.pageSize.getWidth();
        var heightPDF = pdf.internal.pageSize.getHeight();
        pdf.addImage(mapCanvas.toDataURL('image/jpeg'), 'JPEG', 0, 0, widthPDF, heightPDF);
        //pdf.addImage(mapCanvas.toDataURL('image/jpeg'), 'JPEG', 0, 0, dim[0], dim[1]);
        pdf.save('map.pdf');
        // Reset original map size
        _map.setSize(size);
        _map.getView().setResolution(viewResolution);
        document.body.style.cursor = 'auto';
      });

      // Set print size
      var printSize = [width, height];
      _map.setSize(printSize);
      var scaling = Math.min(width / size[0], height / size[1]);
      _map.getView().setResolution(viewResolution / scaling);
    }else{
      // Adapted from: https://openlayers.org/en/latest/examples/export-map.html
      // export options for html-to-image.
      // See: https://github.com/bubkoo/html-to-image#options
      var mapCanvas = document.createElement('canvas');
      mapCanvas.width = size[0];
      mapCanvas.height = size[1];
      var mapContext: CanvasRenderingContext2D = mapCanvas.getContext('2d') as CanvasRenderingContext2D;
      console.log("mapContext", mapContext)
      Array.prototype.forEach.call(document.querySelectorAll('canvas'), function(canvas:any) {
        if (canvas.width > 0) {
          var opacity = canvas.parentNode.style.opacity;
          mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
          var transform = canvas.style.transform;
          if (transform !== ""){
            // Get the transform parameters from the style's transform matrix
            var matrix = transform.match(/^matrix\(([^(]*)\)$/)[1].split(',').map(Number);
            // Apply the transform to the export map context
            CanvasRenderingContext2D.prototype.setTransform.apply(mapContext, matrix);
          }
          mapContext.drawImage(canvas, 0, 0);
        }
      });
      
      if (navigator.msSaveBlob) {
        // link download attribuute does not work on MS browsers
        // navigator.msSaveBlob(mapCanvas.msToBlob(), 'map.png'); // Stock code, throws errors
        navigator.msSaveBlob(mapCanvas.toBlob(function(blob){
          console.log("Blob Complete!")
        }, 'image/jpeg', 0.95), 'Syncarto_Map_ms.png');
      } else {
        mapCanvas.toBlob(function(blob) {
          console.log("window.open() as Window")
          let newTab:Window = window.open() as Window;
          console.log("newTab", newTab)
          if(!newTab || newTab.closed || typeof newTab.closed=='undefined'){
            // Popup blocked, handle special case
            // Auto download image (voice command to open image may be blocked by popup blocker so do this instead)
            console.log("downloading image")
            const link = document.createElement('a');
            link.download = 'Syncarto_Map' + getDateString() + '.png'; // Will force the image to download instead of opening in a new tab.
            link.href = URL.createObjectURL(blob);
            link.target = "_blank";
            link.click();
          }else{
            // Open image in new tab
            console.log("opening image in new tab")
            newTab.location.href = URL.createObjectURL(blob);
          }
        });
      }
    }
};
var handleShipItClick = function( _map:any, _socket:any, _aoiVectorLayer:any) {
  console.log("handleShipItClick > _map, _socket, _aoiVectorLayer", _map, _socket, _aoiVectorLayer)
  _socket.emit('chat', "Ship It");
};

// Helper function, returns timestamp (e.g. )
function getDateString() {
  const date = new Date();
  const year = date.getFullYear();
  const month = `-${date.getMonth() + 1}`.padStart(2, '0');
  const day =`-${date.getDate()}`.padStart(2, '0');
  const hourmin =`_${date.getHours()}${date.getMinutes()}${date.getSeconds()}`;
  return `${year}${month}${day}${hourmin}`
}

function initMeasureTool(app: any, map: any, el: HTMLElement) {
  // see https://openlayers.org/en/v4.6.5/examples/custom-controls.html

  //var measureToolEnabled = false; // CS: replacing this with a string var, "activeTool" to keep track of the status of all tools
  var draw: any; // global so we can remove it later
  var measureType = "LineString"
  var helpTooltipElement: any;
  app.MeasureToolControl = function(opt_options: any) {

    var options = opt_options || {};

    // make main button for measure tool functionality
    var button = document.createElement('button');
    var buttonInner = document.createElement('i');
    buttonInner.setAttribute('class', 'fas fa-ruler');
    buttonInner.setAttribute('title', 'Measure distance or area');
    button.appendChild(buttonInner);

    // Make buttons for line/polygon functionality toggle
    // Polygon button
    var buttonTogglePolygon = document.createElement('button');
    buttonTogglePolygon.setAttribute('class', 'measure-button-toggle-polygon measure-button-area-toggle-hidden');
    var buttonTogglePolygonInner = document.createElement('i');
    buttonTogglePolygonInner.setAttribute('class', 'fas fa-draw-polygon');
    buttonTogglePolygonInner.setAttribute('title', 'Measure an area');
    buttonTogglePolygon.appendChild(buttonTogglePolygonInner);
    // Line button
    var buttonToggleLine = document.createElement('button');
    buttonToggleLine.setAttribute('class', 'measure-button-toggle-line measure-button-area-toggle-hidden');
    var buttonToggleLineInner = document.createElement('i');
    buttonToggleLineInner.setAttribute('class', 'fas fa-ruler-horizontal');
    buttonToggleLineInner.setAttribute('title', 'Measure a distance');
    buttonToggleLine.appendChild(buttonToggleLineInner);


    var measureToolToggleType = function(_type: any) {
      measureType = _type
      const toggleLine = document.querySelector('.measure-button-toggle-line')
      const togglePoly = document.querySelector('.measure-button-toggle-polygon')
      if (measureType === "Polygon"){
        if (togglePoly && toggleLine){ // avoid "Object is possibly 'null'." error 
          toggleLine.classList.remove('measure-button-toggle-selected');
          togglePoly.classList.add('measure-button-toggle-selected');
        }
        map.removeInteraction(draw);
        addInteraction();
      }else{
        if (togglePoly && toggleLine){ // avoid "Object is possibly 'null'." error 
          toggleLine.classList.add('measure-button-toggle-selected');
          togglePoly.classList.remove('measure-button-toggle-selected');
        }
        map.removeInteraction(draw);
        addInteraction();
      }
    }

    var handleMeasureToolToggle = function() {
      const measureToolEl = el.querySelector('.measure-tool i');
      // if (!measureToolEnabled) {
      if (activeTool !== 'measure') {
        if (activeTool !== '') { // If AOI is not already in edit mode and no tool is active, clear all tools.
          resetTools("measure", activeTool)
        }
        console.log("Turning measure tool on")
        addInteraction();
        // Turn on poly/line options 
        const toggleLine = el.querySelector('.measure-button-toggle-line')
        const togglePoly = el.querySelector('.measure-button-toggle-polygon')
        if (togglePoly && toggleLine){ // avoid "Object is possibly 'null'." error 
          togglePoly.classList.remove('measure-button-area-toggle-hidden');
          toggleLine.classList.remove('measure-button-area-toggle-hidden');
          if (measureType === "Polygon"){
            togglePoly.classList.add('measure-button-toggle-selected');
          }else{
            toggleLine.classList.add('measure-button-toggle-selected');
          }
        }
        $(measureToolEl).attr('color', 'primary');
        // measureToolEnabled = true;
        activeTool = 'measure'
      } else {
        console.log("Turning measure tool off")
        map.removeInteraction(draw);
        // Turn off all tooltips 
        const tooltipEl = el.querySelector('.tooltip-ol-help');
        $(tooltipEl).hide();
        const tooltipE2 = el.querySelector('.tooltip-ol');
        $(tooltipE2).hide();
        const tooltipE3 = el.querySelectorAll('.tooltip-static');
        $(tooltipE3).hide();
        // Turn off poly/line options 
        const toggleLine = el.querySelector('.measure-button-toggle-line')
        const togglePoly = el.querySelector('.measure-button-toggle-polygon')
        if (togglePoly && toggleLine){ // avoid "Object is possibly 'null'." error 
          togglePoly.classList.add('measure-button-area-toggle-hidden');
          toggleLine.classList.add('measure-button-area-toggle-hidden');
          toggleLine.classList.remove('measure-button-toggle-selected');
        }
        $(measureToolEl).attr('color', null);
        // measureToolEnabled = false;
        activeTool = ''
        sourceMeasure.clear()
      }
    };

    button.addEventListener('click', handleMeasureToolToggle, false);
    button.addEventListener('touchstart', handleMeasureToolToggle, false);

    // add listeners to line and polygon measure tool options
    buttonToggleLine.addEventListener('click', function(){ measureToolToggleType("LineString") }, false);
    buttonToggleLine.addEventListener('touchstart', function(){ measureToolToggleType("LineString") }, false);
    buttonTogglePolygon.addEventListener('click', function(){ measureToolToggleType("Polygon") }, false);
    buttonTogglePolygon.addEventListener('touchstart', function(){ measureToolToggleType("Polygon") }, false);

    var element = document.createElement('div');
    element.className = 'measure-tool ol-unselectable ol-control';
    element.appendChild(button);
    element.appendChild(buttonToggleLine);
    element.appendChild(buttonTogglePolygon);
    
    Control.call(this, {
      element: element,
      target: options.target
    });

  };
  inherits(app.MeasureToolControl, Control);

  // code for measure tool
  // mostly copy/pasted from https://openlayers.org/en/v4.6.5/examples/measure.html
  var sourceMeasure = new VectorSource();

  var vectorMeasure = new VectorLayer({ // eslint-disable-line no-unused-vars
    source: sourceMeasure,
    style: new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.2)'
      }),
      stroke: new Stroke({
        color: '#ffcc33',
        width: 2
      }),
      image: new Circle({
        radius: 7,
        fill: new Fill({
          color: '#ffcc33'
        })
      })
    })
  });
  vectorMeasure.setZIndex(200); // Measure lines should always be on top, setting z-index accordingly.
  map.addLayer(vectorMeasure)

  /**
   * Currently drawn feature.
   * @type {ol.Feature}
   */
  var sketch: any;


  /**
   * Overlay to show the help messages.
   * @type {ol.Overlay}
   */
  var helpTooltip: any;


  /**
   * The measure tooltip element.
   * @type {Element}
   */
  var measureTooltipElement: any;


  /**
   * Overlay to show the measurement.
   * @type {ol.Overlay}
   */
  var measureTooltip: any;


  /**
   * Message to show when the user is drawing a polygon.
   * @type {string}
   */
  var continuePolygonMsg = 'Click to continue drawing the polygon';


  /**
   * Message to show when the user is drawing a line.
   * @type {string}
   */
  var continueLineMsg = 'Click to continue drawing the line';


  /**
   * Handle pointer move.
   * @param {ol.MapBrowserEvent} evt The event.
   */
  var pointerMoveHandler = function(evt: any) {
    if (evt.dragging) {
      return;
    }

    // if (!measureToolEnabled) {
    if (activeTool !== 'measure') {
      //console.log("measure tool not enabled, exiting")
      return;
    }
    /** @type {string} */
    var helpMsg = 'Click to start drawing';

    if (sketch) {
      var geom = (sketch.getGeometry());
      if (geom instanceof Polygon) {
        helpMsg = continuePolygonMsg;
      } else if (geom instanceof LineString) {
        helpMsg = continueLineMsg;
      }
    }

    helpTooltipElement.innerHTML = helpMsg;
    helpTooltip.setPosition(evt.coordinate);

    helpTooltipElement.classList.remove('hidden-tooltip-ol');
    measureTooltipElement.classList.remove('hidden-tooltip-ol');
  };

  map.on('pointermove', pointerMoveHandler);

  map.getViewport().addEventListener('mouseout', function() {
    // if (measureToolEnabled) {
    if (activeTool === 'measure') {
      console.log("mouse out")
      helpTooltipElement.classList.add('hidden-tooltip-ol');
      measureTooltipElement.classList.add('hidden-tooltip-ol');
    }
  });


  /**
   * Format length output.
   * @param {ol.geom.LineString} line The line.
   * @return {string} The formatted length.
   */
  var formatLength = function(line: any) {
    var length = getLength(line);
    var output;
    if (length > 1609) {
      output = (Math.round(length / 1609.34 * 100) / 100) +
        ' ' + 'mi'; // eslint-disable-line
    } else {
      output = (Math.round(length * 3.28084 * 100) / 100) +
        ' ' + 'ft'; // eslint-disable-line
    }
    return output;
  };


  /**
   * Format area output.
   * @param {ol.geom.Polygon} polygon The polygon.
   * @return {string} Formatted area.
   */
  var formatArea = function(polygon: any) {
    var area = getArea(polygon);
    var output;
    /* TO OUTPUT AS Meters or Kilometers 
    if (area > 10000) {
      output = (Math.round(area / 1000000 * 100) / 100) +
        ' ' + 'km<sup>2</sup>'; // eslint-disable-line
    } else {
      output = (Math.round(area * 100) / 100) +
        ' ' + 'm<sup>2</sup>'; // eslint-disable-line
    }
    */
    // area is in square meters,
    //    1 square meter = 10.7639104 square feet
    //    1 square meter = 0.00000038610 square miles
    var outputSqFt = Math.round(area * 10.7639104);
    var outputSqMi = area * 0.00000038610;
    if (outputSqMi > 0.25) {
      outputSqMi = Number(outputSqMi.toFixed(3));
      if (outputSqMi > 1){
        outputSqMi = Number(outputSqMi.toFixed(2));
      }
      /*
      if (outputSqMi > 10){
        outputSqMi = Number(outputSqMi.toFixed(1));
      }    
      if (outputSqMi > 100){
        outputSqMi = Number(outputSqMi.toFixed());
      }
      */
      output = outputSqMi +
        ' ' + 'mi<sup>2</sup>'; // eslint-disable-line
    } else {
      output = outputSqFt +
        ' ' + 'ft<sup>2</sup>'; // eslint-disable-line
    }
    return output;
  };

  function addInteraction(this: any) { // typescript hack https://stackoverflow.com/questions/48007891/ts2683ts-this-implicitly-has-type-any-because-it-does-not-have-a-type-ann
    // var type = (typeSelect.value == 'area' ? 'Polygon' : 'LineString');
    console.log("addInteraction > this", this)
    var type = measureType; //'LineString';
    console.log("The measurement type is: " + type)
    draw = new Draw({
      source: sourceMeasure,
      type: type,
      style: new Style({
        fill: new Fill({
          color: 'rgba(255, 255, 255, 0.2)'
        }),
        stroke: new Stroke({
          color: 'rgba(0, 0, 0, 0.5)',
          lineDash: [10, 10],
          width: 2
        }),
        image: new Circle({
          radius: 5,
          stroke: new Stroke({
            color: 'rgba(0, 0, 0, 0.7)'
          }),
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)'
          })
        })
      })
    });
    map.addInteraction(draw);

    createMeasureTooltip();
    createHelpTooltip();

    var listener: any;
    draw.on('drawstart',
      function(evt: any) {
        // set sketch
        sketch = evt.feature;

        // @type {ol.Coordinate|undefined}
        var tooltipCoord = evt.coordinate;

        listener = sketch.getGeometry().on('change', function(evt: any) {
          var geom = evt.target;
          var output;
          if (geom instanceof Polygon) {
            output = formatArea(geom);
            tooltipCoord = geom.getInteriorPoint().getCoordinates();
          } else if (geom instanceof LineString) {
            output = formatLength(geom);
            tooltipCoord = geom.getLastCoordinate();
          }
          measureTooltipElement.innerHTML = output;
          measureTooltip.setPosition(tooltipCoord);
        });
      }, this);
    
    draw.on('drawend',
      function() {
        console.log("drawend!")
        measureTooltipElement.className = 'tooltip-ol tooltip-static';
        measureTooltip.setOffset([0, -7]);
        // unset sketch
        sketch = null;
        // unset tooltip so that a new one can be created
        measureTooltipElement = null;
        createMeasureTooltip();
        unByKey(listener);
      }, this);
  }


  /**
   * Creates a new help tooltip
   */
  function createHelpTooltip() {
    if (helpTooltipElement) {
      helpTooltipElement.parentNode.removeChild(helpTooltipElement);
    }
    helpTooltipElement = document.createElement('div');
    helpTooltipElement.className = 'tooltip-ol tooltip-ol-help hidden-tooltip-ol';
    helpTooltip = new Overlay({
      element: helpTooltipElement,
      offset: [15, 0],
      positioning: 'center-left'
    });
    map.addOverlay(helpTooltip);
  }


  /**
   * Creates a new measure tooltip
   */
  function createMeasureTooltip() {
    if (measureTooltipElement) {
      measureTooltipElement.parentNode.removeChild(measureTooltipElement);
    }
    measureTooltipElement = document.createElement('div');
    measureTooltipElement.className = 'tooltip-ol tooltip-measure';
    measureTooltip = new Overlay({
      element: measureTooltipElement,
      offset: [0, -15],
      positioning: 'bottom-center'
    });
    map.addOverlay(measureTooltip);
  }

  // end copy/pasted code for measure tool
};

/*function initMenuExpand(app: any, toggleMenuExpand: any) {

  // ad hoc mechanism for controlling layer visibility, following pattern
  // of measure tool to some extent
  app.MenuExpandControl = function(opt_options: any) {

    const options = opt_options || {};

    const button = document.createElement('button');
    const buttonInner = document.createElement('i');
    buttonInner.setAttribute('class', 'fas fa-bars');
    buttonInner.setAttribute('title', 'Toggle layer list');
    button.appendChild(buttonInner);

    const handleMenuExpandToggle = function() {
      console.log('handleMenuExpandToggle');
      toggleMenuExpand();
    };

    button.addEventListener('click', handleMenuExpandToggle, false);
    button.addEventListener('touchstart', handleMenuExpandToggle, false);

    const element = document.createElement('div');
    element.className = 'menu-expand-button ol-unselectable ol-control';
    element.appendChild(button);

    Control.call(this, {
      element: element,
      target: options.target
    });

  };
  inherits(app.MenuExpandControl, Control);

};*/

function initUseExtentButton(map: any, socket: any, aoiVectorLayer: any, app: any, updateAOIQuery:any) {
  // Button to enable "map use extent" functionality for setting AOI
  // (but via button instead of chat)
  app.UseExtentButton = function(opt_options: any) {

    var options = opt_options || {};

    var button = document.createElement('button');
    var buttonInner = document.createElement('i');
    buttonInner.setAttribute('class', 'fas fa-square');
    buttonInner.setAttribute('title', 'Set area of interest (AOI) to extent of map');
    button.appendChild(buttonInner);

    var handleUseExtentClick = function() {
      doUseMapExtent(map, socket, aoiVectorLayer, updateAOIQuery);
    };

    button.addEventListener('click', handleUseExtentClick, false);
    button.addEventListener('touchstart', handleUseExtentClick, false);

    // Add AOI edit button, and delete AOI button alongside extent rectangle button 
    var buttonEdit = document.createElement('button');
    var buttonDeleteAOI = document.createElement('button');
    buttonEdit.setAttribute('class', 'edit-aoi-button edit-aoi-button-toggle-hidden');
    buttonDeleteAOI.setAttribute('class', 'delete-aoi-button delete-aoi-button-toggle-hidden');
    var buttonEditInner = document.createElement('i');
    var buttonDeleteAOIInner = document.createElement('i');
    buttonEditInner.setAttribute('class', 'edit-aoi-icon fas fa-vector-square');
    buttonEditInner.setAttribute('title', 'Edit area of interest (AOI)');
    buttonDeleteAOIInner.setAttribute('class', 'edit-aoi-icon fas fa-eraser');
    buttonDeleteAOIInner.setAttribute('title', 'Remove area of interest (AOI)');
    buttonEdit.appendChild(buttonEditInner);
    buttonDeleteAOI.appendChild(buttonDeleteAOIInner);

    // Handle edit AOI
    var handleEditAOIClick = function() {
      /* select, modify, snap, map are global objects */
      console.log("handleEditAOIClick()")
      doEditMap(select, modify, snap, map, aoiVectorLayer, socket, updateAOIQuery);
    }
    buttonEdit.addEventListener('click', handleEditAOIClick, false);
    buttonEdit.addEventListener('touchstart', handleEditAOIClick, false);
    
    // Handle delete AOI
    var handleDeleteAOIClick = function() {
      doClearAOI(map, socket, aoiVectorLayer, "button", updateAOIQuery);
    }
    buttonDeleteAOI.addEventListener('click', handleDeleteAOIClick, false);
    buttonDeleteAOI.addEventListener('touchstart', handleDeleteAOIClick, false);

    var element = document.createElement('div');
    element.className = 'use-extent-button ol-unselectable ol-control';
    element.appendChild(button);
    element.appendChild(buttonEdit);
    element.appendChild(buttonDeleteAOI);

    Control.call(this, {
      element: element,
      target: options.target
    });

  };
  inherits(app.UseExtentButton, Control);

};

function initMapPrintButton(map: any, app: any) {

  // Button to print the current map view
  app.mapPrintButton = function(opt_options: any) {

    var options = opt_options || {};

    var button = document.createElement('button');
    var buttonInner = document.createElement('i');
    buttonInner.setAttribute('class', 'fas fa-file-export');
    buttonInner.setAttribute('title', 'Export the map to image');
    button.appendChild(buttonInner);

    var element = document.createElement('div');
    element.className = 'map-print-button ol-unselectable ol-control';
    element.appendChild(button);

    /* For exposing the png and pdf export buttons, removed for now
    var buttonPDF = document.createElement('button');
    buttonPDF.setAttribute('class', 'print-pdf-button print-button-hidden');
    var buttonInnerPDF = document.createElement('i');
    buttonInnerPDF.setAttribute('class', 'fas fa-file-pdf');
    buttonInnerPDF.setAttribute('title', 'Export the map to PDF');
    buttonPDF.appendChild(buttonInnerPDF);

    var buttonPNG = document.createElement('button');
    buttonPNG.setAttribute('class', 'print-png-button print-button-hidden');
    var buttonInnerPNG = document.createElement('i');
    buttonInnerPNG.setAttribute('class', 'fas fa-file-image');
    buttonInnerPNG.setAttribute('title', 'Export the map to PNG');
    buttonPNG.appendChild(buttonInnerPNG);

    element.appendChild(buttonPDF);
    element.appendChild(buttonPNG);

    var revealExportOptions = function() {
      var pngOption:HTMLElement = document.querySelector('.print-png-button') as HTMLElement;
      var pdfOption:HTMLElement = document.querySelector('.print-pdf-button') as HTMLElement;
      if (pngOption.classList.contains('print-button-hidden')){
        pdfOption.classList.remove('print-button-hidden');
        pngOption.classList.remove('print-button-hidden');
      }else{
        pdfOption.classList.add('print-button-hidden');
        pngOption.classList.add('print-button-hidden');
      }
    }

    buttonPNG.addEventListener('click', function(){ handleMapPrintClick("png", map, "PNG Button")}, false);
    buttonPNG.addEventListener('touchstart', function(){ handleMapPrintClick("png", map, "PNG Button")}, false);
    buttonPDF.addEventListener('click', function(){ handleMapPrintClick("pdf", map, "PDF Button")}, false);
    buttonPDF.addEventListener('touchstart', function(){ handleMapPrintClick("pdf", map, "PDF Button")}, false);
    button.addEventListener('click', revealExportOptions, false);
    button.addEventListener('touchstart', revealExportOptions, false);
    */

    button.addEventListener('click', function(){ handleMapPrintClick("png", map, "PNG Button")}, false);
    button.addEventListener('touchstart', function(){ handleMapPrintClick("png", map, "PNG Button")}, false);

    Control.call(this, {
      element: element,
      target: options.target
    });

  };
  inherits(app.mapPrintButton, Control);
}
function initShipItButton(map: any, app: any, socket: any, aoiVectorLayer:any) {

  // Button to print the current map view
  app.shipItButton = function(opt_options: any) {

    var options = opt_options || {};

    var button = document.createElement('button');
    var buttonInner = document.createElement('i');
    buttonInner.setAttribute('class', 'fa fa-clone');
    buttonInner.setAttribute('title', 'Clip, zip, ship current AOI');
    button.appendChild(buttonInner);

    var element = document.createElement('div');
    element.className = 'map-shipIt-button ol-unselectable ol-control';
    element.appendChild(button);

    button.addEventListener('click', function(){ handleShipItClick( map, socket, aoiVectorLayer)}, false);
    button.addEventListener('touchstart', function(){ handleShipItClick( map, socket, aoiVectorLayer)}, false);

    Control.call(this, {
      element: element,
      target: options.target
    });

  };
  inherits(app.shipItButton, Control);
};


function initTileDownloadButton(map: any, handleTileOutlinesRequest: any, tileOutlinesLayer:any, selectedLayer: any, selectedParcelLayer: any, infoOverlay:any, app: any) {

  // Button to show tile outlines within AOI of the top tile layer
  // according to the layer list. clicking one of the tile outlines
  // will give you links to download the raw tiles
  app.TileDownloadButton = function(opt_options: any) {

    var options = opt_options || {};

    // Add button to map for engaging the (i) info tool
    var button = document.createElement('button');
    var buttonInner = document.createElement('i');
    buttonInner.setAttribute('class', 'info-button fas fa-info');
    buttonInner.setAttribute('title', 'Display image tiles for download');
    button.appendChild(buttonInner);

    var handleTileDownloadClick = function() {
      let selectedInfoButton = document.querySelector('.info-button') as HTMLElement;
      if (selectedInfoButton.classList.contains('fa-info')){
        // easiest to go back to mapWidget to do this so it can
        // reference the current state of the layer selector
        handleTileOutlinesRequest();
        // Manage status of the clear tiles tool
        selectedInfoButton.classList.remove('fa-info')
        selectedInfoButton.classList.add('fa-eraser')
        selectedInfoButton.setAttribute('title', 'Clear image tiles');
      }else{
        // Clear tiles (green), selection (red), and popup (if one is open)
        clearInfoButtonTiles()
        // Manage status of the clear tiles tool
        selectedInfoButton.classList.add('fa-info')
        selectedInfoButton.classList.remove('fa-eraser')
        selectedInfoButton.setAttribute('title', 'Display image tiles for download');
      }
    };

    var clearInfoButtonTiles = function() {
      console.log("clearInfoButtonTiles()")
      tileOutlinesLayer.getSource().clear() // Clear the existing source, which contains the green image tiles
      console.log("CLEARING selectedLayer's source (b)")
      selectedLayer.getSource().clear()     // Clear the selection's source, which contains the red (selected) image tile
      closeImageInfoPopup();
    };

    button.addEventListener('click', handleTileDownloadClick, false);
    button.addEventListener('touchstart', handleTileDownloadClick, false);

    var element = document.createElement('div');
    element.className = 'tile-download-button ol-unselectable ol-control';
    element.appendChild(button);

    Control.call(this, {
      element: element,
      target: options.target
    });

  };
  inherits(app.TileDownloadButton, Control);

};

const closeImageInfoPopup = function(){
  console.log(infoOverlay)
  infoOverlay.setPosition(undefined);       // Clear the popup, if one exists
  //infoOverlay.setPosition(undefined);
}

/*const tilePixels = new Projection({
  code: 'TILE_PIXELS',
  units: 'tile-pixels'
});*/

/*
const geojsonVtReplacer = function(_: any, value: any) {
  if (value.geometry) {
    var type;
    var rawType = value.type;
    var geometry = value.geometry;

    if (rawType === 1) {
      type = 'MultiPoint';
      if (geometry.length === 1) {
        type = 'Point';
        geometry = geometry[0];
      }
    } else if (rawType === 2) {
      type = 'MultiLineString';
      if (geometry.length === 1) {
        type = 'LineString';
        geometry = geometry[0];
      }
    } else if (rawType === 3) {
      type = 'Polygon';
      if (geometry.length > 1) {
        type = 'MultiPolygon';
        geometry = [geometry];
      }
    }

    return {
      'type': 'Feature',
      'geometry': {
        'type': type,
        'coordinates': geometry
      },
      'properties': value.tags
    };
  } else {
    return value;
  }
};
*/
// Style DW points on value
/*
var getZIndex = function (feature: any) {
  return feature.values_.rank;
} 
*/
/*
var styleDWPoint = function (feature: any) {
  // Scale the points between values of 2 and 10
  console.log("feature, ", feature)
  let high = feature.values_.load_count_high; 
  let low = feature.values_.load_count_low; 
  let ft_value = feature.values_.load_count; 
  let _color = feature.values_.color; 
  //let radius = (((high - ft_value)/(high - low)) * 8) + 2;
  let radius = 6;
  if (high !== low){ // If only one feature is returned from the query then scale function will not work, use a constant instead.
    radius = (((ft_value - low)/(high - low)) * 8) + 4;
  }
  
  var styleDW = new Style({
    image: new Circle({
      radius: radius,
      fill: new Fill({
        color: _color
      }),
      stroke: new Stroke({
        color: 'white',
        width: 0.75
      })
    })
  })
  return styleDW;
}
*/

//This function will take a feature set from DW query and put it on map as WebGL Point layer
async function initGraphqlVectorLayer(_dwdata: any, map: any,layerTitle: any,_dwdataQueryConfig: any, _dwdataLayerStyle: any, _dwdataChartType: any, layerToUpdate: any, query:any, layerType:any, layerCitation:string, layerVisibility:boolean) {
  console.log("Building WebGL Point Layer or GeoJSON Polygon with these parameters:");
  console.log(" _dwdataQueryConfig", _dwdataQueryConfig);
  console.log(" _dwdata, ", _dwdata);
  console.log("layerType", layerType);
  console.log("layerToUpdate", layerToUpdate);
  console.log("query", query);
  console.log(" _dwdataLayerStyle", _dwdataLayerStyle);
  
  if (!_dwdata){
    return;
  }

  //////////// WebGL START
  // Log Inputs
  //
  if (layerToUpdate){
    if (map.originalLayerOrder){
      for(var lyr in map.originalLayerOrder) {
        let titleOriginal = "";
        if (map.originalLayerOrder[lyr].title){
          titleOriginal = map.originalLayerOrder[lyr].title;
        }else{
          titleOriginal = map.originalLayerOrder[lyr].get('title')
        }
        if ( titleOriginal === layerToUpdate.get('title')){
          let isVisible = true;
          if (map.originalLayerOrder[lyr].values_){
            isVisible = map.originalLayerOrder[lyr].values_.visible;
          }else{
            isVisible = map.originalLayerOrder[lyr].visible;
          }
          layerToUpdate.values_.visible = isVisible;
          layerToUpdate.visible = isVisible;
      }
      }
    }
  }

  // Find the name of the metric field returned from query
  //
  
  function validateStatMetric(_dwdataQueryConfig:any, _dwdata:any) {
    let statMetric = "";
    if(_dwdataQueryConfig.measure && _dwdataQueryConfig.measure.source.item) {
      console.log("120623 _dwdataQueryConfig", _dwdataQueryConfig);
      console.log("120623 statMetric > _dwdataQueryConfig.measure", _dwdataQueryConfig.measure);
      console.log("120623 _dwdata", _dwdata);
      if(isStats(_dwdataQueryConfig.measure.source.item)) {
        statMetric = `${_dwdataQueryConfig.measure.source.item!.property}_${_dwdataQueryConfig.measure.source.sub}`;
      } else {
        if(isProperty(_dwdataQueryConfig.measure.source.item)) {
          statMetric = `${_dwdataQueryConfig.measure.source.item!.name}_${_dwdataQueryConfig.measure.source.sub}`;
        }else{
          statMetric = `${_dwdataQueryConfig.measure.source.item!.name}_${_dwdataQueryConfig.measure.aggregation}`;
        }
      }
      let validatedStatMetric = false;
      // There are scenarios where the property.name is not identical to the property.propery (e.g. "Crackout (%)" vs "Crackout") which causes the key to be incorrect and data to be undefined at the
      // when using the statMetric found above above. Below will check the first 100 features to see if the statMetric is valid, if not it will use the inverse logic of the above instead. 
      //
      _dwdata.features.slice(0, 100).forEach((feature:any) => {
        if (feature.properties[statMetric]){
          validatedStatMetric = true;
        }
      })
      if (!validatedStatMetric){
        if(isStats(_dwdataQueryConfig.measure.source.item)) {
          statMetric = `${_dwdataQueryConfig.measure.source.item!.name}_${_dwdataQueryConfig.measure.source.sub}`;
        } else {
          if(isProperty(_dwdataQueryConfig.measure.source.item)) {
            statMetric = `${_dwdataQueryConfig.measure.source.item!.property}_${_dwdataQueryConfig.measure.source.sub}`;
          }else{
            statMetric = `${_dwdataQueryConfig.measure.source.item!.property}_${_dwdataQueryConfig.measure.aggregation}`;
          }
        }
      }
    }
    return statMetric;
  }
  
  var statMetric = validateStatMetric(_dwdataQueryConfig, _dwdata);

  console.log("120623 DW layer's statMetric", statMetric);
  var features_ = [];
  var features = [];
  var highValue = 0;
  var lowValue = 0;
  _dwdataLayerStyle["layerType"] = layerType;
  console.log("120623  layerType", layerType);
  if (layerType === "GeoJSON"){
    console.log("120623 _dwdataLayerStyle", _dwdataLayerStyle);
    if (_dwdataLayerStyle.maxVal && _dwdataLayerStyle.minVal){
      highValue = _dwdataLayerStyle.maxVal; // Hard-code MAX DW Poly
      lowValue = _dwdataLayerStyle.minVal; // Hard-code MIN DW Poly
    }else{
      highValue = _dwdataLayerStyle.maxValue;
      lowValue = _dwdataLayerStyle.minValue;
    }
  }else{
    // Sort features, then find the high/low value
    //
    if (_dwdata){
      features_ = _dwdata.features;
      console.log("features_", features_);
      if (features_){
        features = features_.sort(function(a:any, b:any) {
          return b.properties[statMetric] - a.properties[statMetric];
        });
      }
    }

    //Find the high/low value for this feature set
    //
    console.log("120623 features", features);
    if (features.length <= 0){
      console.log("120623 features.length", features.length);
    }else{
      console.log("120623 _dwdataLayerStyle", _dwdataLayerStyle);
      if (_dwdataLayerStyle.maxVal && _dwdataLayerStyle.minVal){
        console.log("120623 _dwdataLayerStyle null ?");
        highValue = _dwdataLayerStyle.maxVal; // Hard-code MAX DW Point
        lowValue = _dwdataLayerStyle.minVal; // Hard-code MIN DW Point
      }else{
        console.log("120623 statMetric", statMetric);
        console.log("120623 features[0].properties", features[0].properties);
        console.log("120623 features[features.length - 1].properties", features[features.length - 1].properties);
        highValue = features[0].properties[statMetric]; // Hard-code MAX DW Point
        lowValue = features[features.length - 1].properties[statMetric]; // Hard-code MIN DW Point
      }
      if (!highValue){ highValue = 0 } 
      if (!lowValue){ lowValue = 0 } 
    }
  }
  console.log("highValue", highValue);
  console.log("lowValue", lowValue);

  // Make high/low value availiable on the feature set
  //
  _dwdataLayerStyle.maxVal = highValue;
  _dwdataLayerStyle.minVal = lowValue;

  if (layerToUpdate){
    // If it exists, update layer's max/min to trace value back to TOC card
    layerToUpdate.dwdataLayerStyle.maxVal = highValue; 
    layerToUpdate.dwdataLayerStyle.minVal = lowValue;
  } 

  if (layerType === "GeoJSON"){
    const styleFunction = function (feature:any) {
      // If no data available to symbolize, use default symbology
      //
      //console.log("_dwdataLayerStyle", _dwdataLayerStyle);
      //console.log("styleFunction feature", feature);
      
      let dashStroke:number = ((map.getView().getZoom() * 10) / 20);
      let nullStyle = new Style({
        fill: new Fill({
          color:'rgba(255,0,0,0)'
        }),
        stroke: new Stroke({
          color: '#000000',
          width: 1,
          lineDash: [dashStroke,dashStroke]
        })
      });

      if (!feature.values_[statMetric]){
        return nullStyle;
      }
      // Helper functions
      //
      function hexToRGB(hex:any) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? [
          parseInt(result[1], 16),
          parseInt(result[2], 16),
          parseInt(result[3], 16)
        ] : null;
      }
      const interpolate = (start:any,end:any,ratio:any)=>{    
        const r = Math.trunc(ratio*end[0] + (1-ratio)*start[0])
        const g = Math.trunc(ratio*end[1] + (1-ratio)*start[1])
        const b = Math.trunc(ratio*end[2] + (1-ratio)*start[2])    
        return [r,g,b]
      }
      const parseColorArray = (rgbString:any)=>{    
        let colorArr = rgbString.slice(
          rgbString.indexOf("(") + 1, 
          rgbString.indexOf(")")
        ).split(",");
        let colors:any = []
        colorArr.forEach((k:any, i:any) => {
            colors.push(parseInt(k))
        })   
        return colors;
      }
      // Prepare colors based off of color ramp which returne hex or rgb depending on the ramp chosen
      // 
      var _highRenderedColor = _dwdataLayerStyle.highRenderedColor; // hex color
      var _lowRenderedColor = _dwdataLayerStyle.lowRenderedColor; 

      let value = feature.values_[statMetric];
      console.log('lowValue, highValue, value', lowValue, highValue, value);
      highValue = _dwdataLayerStyle.maxVal;
      lowValue = _dwdataLayerStyle.minVal;
      const colorStyle = colorStyleToGeoJSONStyle(_highRenderedColor, lowValue, highValue, value); // returns [highColor, lowColor, val]
      console.log('colorStyle', colorStyle);
      let colorIntrerpolated:any;
      if (colorStyle[0] == null ){
        colorIntrerpolated = colorStyle[2]; 
        /*if (colorLow.startsWith("#")){ // HEX
          colorLow = hexToRGB(colorStyle[4]);
          colorHigh = hexToRGB(colorStyle[colorStyle.length - 1]);
        }else{ // RGB 
          colorLow = parseColorArray(colorStyle[4]);
          colorHigh = parseColorArray(colorStyle[colorStyle.length - 1]);
        }*/
      }else{
        let val = colorStyle[2];
        let highDomainVal = colorStyle[0][0];
        let lowDomainVal = colorStyle[1][0];
        let pct = (val - lowDomainVal) / (highDomainVal - lowDomainVal); // (5 - 0) / (10 - 0) = 0.5
        if (isNaN(pct)){
          if (val == null) {
            colorIntrerpolated = parseColorArray(colorStyle[1][1]); // If no measure was selected, then no stats are available for rendering on color ramp. Set color to first color on ramp.
          }else{
            if (highDomainVal == val) {
              colorIntrerpolated = parseColorArray(colorStyle[0][1]);
            }        
            if (lowDomainVal == val) {
              colorIntrerpolated = parseColorArray(colorStyle[1][1]);
            }
          }
        }else{
          colorIntrerpolated = interpolate(parseColorArray(colorStyle[1][1]),parseColorArray(colorStyle[0][1]),pct)
        }
        colorIntrerpolated = `rgba(${colorIntrerpolated},0.5)`
      }
      console.log('colorIntrerpolated', colorIntrerpolated);
      return new Style({
          fill: new Fill({
            color: colorIntrerpolated
          }),
          stroke: new Stroke({
            color: '#fff',
            width: 1
          })
      })
    };
    // End styleFunction

    console.log("Put Geojson on map _dwdata", _dwdata)
    if (!_dwdata.features){
      _dwdata = { "type": "FeatureCollection", "crs": { "type": "name", "properties": { "name": "EPSG:4326" } }, "features": [] }
    }

    const dwsource = new VectorSource({
        features: new GeoJSON().readFeatures(_dwdata, {
          dataProjection: 'EPSG:4326',
          featureProjection: 'EPSG:3857',
        }),
        attributions: layerCitation
    });
    
    if (layerToUpdate){
      console.log("A011022 layerToUpdate", layerToUpdate)
      layerToUpdate.setSource(dwsource);
      console.log("A011022 moment", moment(convertFromEpoch(layerToUpdate.MapLayerAndDateRange.state.yearEnd)).format('YYYY-MM-DD'))
      console.log("A011022 moment", moment(convertFromEpoch(layerToUpdate.MapLayerAndDateRange.state.yearStart)).format('YYYY-MM-DD'))
      layerToUpdate["dwdataQueryConfig"] = _dwdataQueryConfig;
      layerToUpdate["dwdataChartType"] = _dwdataChartType;
      layerToUpdate["dwdata"] = _dwdata;
      
    }else{
      const dwlayer = new VectorLayer({
        source: dwsource,
        style: styleFunction,
      });

      // Push the DW layer query configuration as "dwdataQueryConfig" (without spatial filter) onto the layer so that it can be used to persist.
      // 
      dwlayer["dwdataQueryConfig"] = _dwdataQueryConfig;
      dwlayer["dwdataChartType"] = _dwdataChartType;
      dwlayer["dwdataLayerStyle"] = _dwdataLayerStyle;
      dwlayer["dwdata"] = _dwdata;
      console.log("C122821 _dwdataLayerStyle",_dwdataLayerStyle)
      let momentDateMin = moment(_dwdataLayerStyle.minDate).format('YYYY-MM-DD');
      var minDate:any = new Date(momentDateMin);
      var minDaysSinceEpoch = Math.floor(minDate/8.64e7);
      let momentDateMax = moment(_dwdataLayerStyle.maxDate).format('YYYY-MM-DD');
      var maxDate:any = new Date(momentDateMax);
      var maxDaysSinceEpoch = Math.floor(maxDate/8.64e7);
      dwlayer["yearStart"] = minDaysSinceEpoch;
      dwlayer["yearEnd"] = maxDaysSinceEpoch;
      dwlayer["processedFeatures"] = []; // Not needed on GeoJSON layer



      console.log("Creating new DW GeoJSON layer... dwlayer", dwlayer);
      map.addLayer(dwlayer)
      dwlayer.setZIndex(100);
      dwlayer.setVisible(layerVisibility);
      // Give layer a title.
      //
      dwlayer.set('title', layerTitle);

      // Add layer to the TOC layer list.
      //
      console.log("Adding new DW GeoJSON layer to TOC..")
      dwlayer.dwdataLayerStyle.maxVal = highValue; 
      dwlayer.dwdataLayerStyle.minVal = lowValue;
      if (map.originalLayerOrder){
        for (const lyr of map.originalLayerOrder) { 
          let lyrTitle = "";
          if (lyr.title){
            lyrTitle = lyr.title;
          }else{
            lyrTitle = lyr.get('title')
          }
          if ( lyrTitle === dwlayer.get('title')){
            let isVisible = true;
            if (lyr.values_){
              isVisible = lyr.values_.visible;
            }else{
              isVisible = lyr.visible;
            }
            dwlayer.values_.visible = isVisible;
            dwlayer.visible = isVisible;
        }
      }
    }
    addRemoveComponentLayerDW(dwlayer,false, false, "1332");
  }
  }else{
    // WebGL Point Layer (OpenLayers 6.5.0) --> resources used to create this logic, spring 2021
    //    * the 'var' parameter within WebGL Points Layer Style was not used due to inconsistent performance and an apparent limitation in adjusting hex value colors. 
    //    https://openlayers.org/en/latest/examples/filter-points-webgl.html (See lines 34-38 specifically)
    //    https://openlayers.org/en/latest/examples/webgl-points-layer.html (See "Reading operators" section for some explanation of 'var' and 'get' to use varables)
    //    https://github.com/openlayers/openlayers/issues/10381 (a related thread, looking closer at this now )
    //    https://openlayers.org/workshop/en/webgl/points.html
    //    https://openlayers.org/en/latest/apidoc/

    // Process data into format ready for WebGL Point Layer
    //
    var raw_features = _dwdata.features;
    var processed_features: any = [];
    
    if (raw_features){
      raw_features.forEach((ft: any) => {
        if (ft.geometry){
          processed_features.push(
            new Feature({
              geometry: new Point(fromLonLat(ft.geometry.coordinates)),
              properties: ft.properties,
              rendered_val: ft.properties[statMetric],
              feature_type: "data warehouse point",
            })
          )
        }
      });
    }else{
      console.log("No data for this query.")
    }

    // Create the WebGL style object
    //
    var layerStyle = {};
    var _highRenderedColor = _dwdataLayerStyle.highRenderedColor; // hex color
    var _lowRenderedColor = _dwdataLayerStyle.lowRenderedColor;  
    var _highRenderedPoint = parseInt(_dwdataLayerStyle.highRenderedPoint); // point size
    var _lowRenderedPoint = parseInt(_dwdataLayerStyle.lowRenderedPoint);

    const colorStyle = colorStyleToWebGlStyle(_highRenderedColor, lowValue, highValue);
    console.log('colorStyle2', _highRenderedColor, colorStyle, _highRenderedPoint,_lowRenderedPoint);

    layerStyle = {
      symbol: {
        symbolType: 'circle',
        size:[
          'interpolate',
          ['linear'],
          ['get', 'rendered_val'],
          lowValue, 
          _lowRenderedPoint,
          highValue,
          _highRenderedPoint
        ],
        color: colorStyle,
        offset: [0, 0],
        opacity: 0.95,
      },
    }

    const vectorLayer = new WebGLPointsLayer({
      source: new VectorSource(),
      style: layerStyle,
      disableHitDetection: false,
    })

    // Push the DW layer query configuration as "dwdataQueryConfig" (without spatial filter) onto the layer so that it can be used to persist.
    // 
    vectorLayer["dwdataQueryConfig"] = _dwdataQueryConfig;
    vectorLayer["dwdataChartType"] = _dwdataChartType;
    vectorLayer["dwdataLayerStyle"] = _dwdataLayerStyle;
    vectorLayer["processedFeatures"] = processed_features;

    if (layerToUpdate){
      map.removeLayer(layerToUpdate);
      addRemoveComponentLayerDW(layerToUpdate, true, false, "1292");
      layerToUpdate.dispose();
    }

    console.log("Creating new DW layer...");
    map.addLayer(vectorLayer)
    vectorLayer.setZIndex(100);
    vectorLayer.setVisible(layerVisibility);
    if (processed_features){
      vectorLayer.getSource().addFeatures(processed_features);
    }else{
      vectorLayer.getSource().addFeatures([{
        "disposed": false,
        "pendingRemovals_": {},
        "dispatching_": {},
        "listeners_": {
          "change:geometry": [
            null
          ]
        },
        "revision_": 1,
        "ol_uid": "139",
        "values_": {
          "geometry": {
            "disposed": false,
            "pendingRemovals_": null,
            "dispatching_": null,
            "listeners_": {
              "change": [
                null
              ]
            },
            "revision_": 1,
            "ol_uid": "138",
            "values_": null,
            "extent_": [
              null,
              null,
              null,
              null
            ],
            "extentRevision_": -1,
            "simplifiedGeometryMaxMinSquaredTolerance": 0,
            "simplifiedGeometryRevision": 0,
            "layout": "XY",
            "stride": 2,
            "flatCoordinates": [
              0,
              0
            ]
          },
          "properties": {
            "rendered_val": 0,
          },
          "rendered_val": 0,
          "feature_type": "data warehouse point"
        },
        "geometryName_": "geometry",
        "style_": null,
        "geometryChangeKey_": {
          "target": {
            "disposed": false,
            "pendingRemovals_": null,
            "dispatching_": null,
            "listeners_": {
              "change": [
                null
              ]
            },
            "revision_": 1,
            "ol_uid": "138",
            "values_": null,
            "extent_": [
              null,
              null,
              null,
              null
            ],
            "extentRevision_": -1,
            "simplifiedGeometryMaxMinSquaredTolerance": 0,
            "simplifiedGeometryRevision": 0,
            "layout": "XY",
            "stride": 2,
            "flatCoordinates": [
              0,
              0
            ]
          },
          "type": "change"
        }
      }])
    }
    

    // Give layer a title.
    vectorLayer.set('title', layerTitle);
    
    // Add layer to the TOC layer list.
    //
    console.log("Adding new DW layer to TOC..")
    vectorLayer.dwdataLayerStyle.maxVal = highValue; 
    vectorLayer.dwdataLayerStyle.minVal = lowValue;
    if (map.originalLayerOrder){
      for (const lyr of map.originalLayerOrder) { 
        let lyrTitle = "";
        if (lyr.title){
          lyrTitle = lyr.title;
        }else{
          lyrTitle = lyr.get('title')
        }
        if ( lyrTitle === vectorLayer.get('title')){
          let isVisible = true;
          if (lyr.values_){
            isVisible = lyr.values_.visible;
          }else{
            isVisible = lyr.visible;
          }
          vectorLayer.values_.visible = isVisible;
          vectorLayer.visible = isVisible;
        }
      }
    }
    addRemoveComponentLayerDW(vectorLayer,false, false, "1394B");
  }
  //////////// WebGL END
};

//This function will take parameters from UI and render a service layer (WMS, WMTS, WFS and XYZ, MVT layers)
async function initOLServiceLayer(map: any, layerTitle: any, serviceConfig: any, layerStyle: any, chartType: any, layerToUpdate: any, layerVisibility:boolean) {
  console.log("Building Service Layer with these parameters:");
  console.log("layerTitle", layerTitle);
  console.log("serviceConfig", serviceConfig);
  console.log("layerStyle", layerStyle);
  console.log("chartType", chartType);
  console.log("layerToUpdate", layerToUpdate);
  console.log("layerVisibility", layerVisibility);
  
  if (!serviceConfig){
    return;
  }

  let serviceLayer
  if (serviceConfig.type == "XYZ"){
    serviceLayer = new TileLayer({
      source: new XYZ({
        url: serviceConfig.URL,
      }),
    })
  }else{
    serviceLayer = new VectorTileLayer({
      declutter: true,
      source: new VectorTileSource({
        /*attributions:
          '© <a href="https://...">...</a> '*/
        format: new MVT(),
        url: serviceConfig.URL,
      }),
      //style: createMapboxStreetsV6Style(Style, Fill, Stroke, Icon, Text),
    })
  }
  
  // Push the service layer configuration as onto the layer so that it can be used to persist.
  serviceLayer["serviceLayerConfig"] = serviceConfig;
  serviceLayer["serviceLayerStyle"] = layerStyle;

  if (layerToUpdate){
    /*
    map.removeLayer(layerToUpdate);
    addRemoveComponentLayerDW(layerToUpdate, true, false, "1292");
    layerToUpdate.dispose();
    */
  }

  console.log("Creating new service layer...");
  map.addLayer(serviceLayer)
  serviceLayer.setZIndex(90);
  serviceLayer.setVisible(layerVisibility);
  // Give layer a title.
  serviceLayer.set('title', layerTitle);
  console.log("New service layer added to map...");
  
  addRemoveComponentLayerDW(serviceLayer,false, false, "1394A");
};

function initOtherVectorLayers(map: any, el: HTMLElement, socket: any, queryConnection:any) {
  console.log("initOtherVectorLayers()")
  // copy pasted code for parcel info on click poup
  // https://openlayers.org/en/latest/examples/popup.html
  /**
   * Elements that make up the popup.
   */
  var container = el.querySelector('#popup') as HTMLElement;
  var content = el.querySelector('#popup-content') as HTMLElement;
  var closer = el.querySelector('#popup-closer') as HTMLElement;

  var selectedSource = new VectorSource();
  var selectedLayer = new VectorLayer({
    zIndex: 103,
    source: selectedSource,
    style: new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.0)'
      }),
      stroke: new Stroke({
        color: '#f95454',  // '#f95454' is a red 
        width: 2,
      })
    })
  });  
  
  var selectedParcelSource = new VectorSource();
  var selectedParcelLayer = new VectorLayer({
    zIndex: 104, // always want on top of main parcel layer
    source: selectedParcelSource,
    style: new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.0)'
      }),
      stroke: new Stroke({
        color: '#007bff',  // '#f95454' is a red 
        width: 2,
      })
    })
  });


  /**
   * Add a click handler to hide the popup.
   * @return {boolean} Don't follow the href.
   */
  closer.onclick = function() {
    // on close of image info popup
    infoOverlay.setPosition(undefined);
    console.log("CLEARING selectedLayer's source (c)")
    selectedLayer.getSource().clear()      // Clear the selection's source, which contains the red (selected) image tile
    closer.blur();
    return false;
  };

  const selectedEntitySource = new VectorSource();
  var selectedFeature = new Feature();

  // end copy pasted code for parcel info on click poup
  // copy pasted code for parcel info on click poup
  // https://openlayers.org/en/latest/examples/popup.html
  /**
   * Elements that make up the popup.
   */
  var dwContainer = document.querySelector('#dw-popup') as HTMLElement;
  var dwContent = document.querySelector('#dw-popup-content') as HTMLElement;
  var dwTabContent = document.querySelector('#dw-popup-tabcontent') as HTMLElement;
  var dwTabContentInfo = document.querySelector('#dw-popup-tabcontent-info') as HTMLElement;
  var dwTabContentContact = document.querySelector('#dw-popup-tabcontent-contact') as HTMLElement;
  var dwTabContentAddress = document.querySelector('#dw-popup-tabcontent-address') as HTMLElement;
  var dwTitle = document.querySelector('#dw-popup-header-title') as HTMLElement;
  var dwCloser = document.querySelector('#dw-popup-closer') as HTMLElement;  
  
  var dwFieldContainer = document.querySelector('#dw-field-popup') as HTMLElement;
  var dwFieldContent = document.querySelector('#dw-field-popup-content') as HTMLElement;
  var dwFieldTitle = document.querySelector('#dw-field-popup-header-title') as HTMLElement;
  var dwFieldCloser = document.querySelector('#dw-field-popup-closer') as HTMLElement;  
  var dwFieldNext = document.querySelector('#dw-field-popup-next') as HTMLElement;  
  var dwFieldPrev = document.querySelector('#dw-field-popup-prev') as HTMLElement;  
  var dwFieldOf = document.querySelector('#dw-field-popup-of') as HTMLElement;  
  var dwFieldQueue = {
    "features":["none"],
    "selection_index":0
  };
  
  var genericContainer = document.querySelector('#generic-popup') as HTMLElement;
  var genericContent = document.querySelector('#generic-popup-content') as HTMLElement;
  var genericTitle = document.querySelector('#generic-popup-header-title') as HTMLElement;
  var genericCloser = document.querySelector('#generic-popup-closer') as HTMLElement;

  /**
   * Create an overlay to anchor the popup to the map.
   */
  dwPointOverlay = new Overlay({
    element: dwContainer,
    autoPan: true,
    autoPanAnimation: {
      duration: 250
    }
  });
  map.addOverlay(dwPointOverlay);  

  dwFieldOverlay = new Overlay({
    element: dwFieldContainer,
    autoPan: true,
    autoPanAnimation: {
      duration: 250
    }
  });
  map.addOverlay(dwFieldOverlay);  
  
  /**
   * Create an overlay to anchor the popup to the map.
   */
  genericPointOverlay = new Overlay({
    element: genericContainer,
    autoPan: true,
    autoPanAnimation: {
      duration: 250
    }
  });
  map.addOverlay(genericPointOverlay);
  /**
   * Create an overlay to anchor the popup to the map.
   */
  infoOverlay = new Overlay({
    element: container,
    autoPan: true,
    autoPanAnimation: {
      duration: 250
    }
  });
  map.addOverlay(infoOverlay);
  /**
   * Add a click handler to hide the popup.
   * @return {boolean} Don't follow the href.
   */
  dwCloser.onclick = function() {
    dwPointOverlay.setPosition(undefined);
    selectedLayer.getSource().clear()      // Clear the selection's source, which contains the red (selected) image tile
    dwCloser.blur();
    return false;
  };  
  dwFieldCloser.onclick = function() {
    dwFieldOverlay.setPosition(undefined);
    selectedLayer.getSource().clear()      // Clear the selection's source, which contains the red (selected) image tile
    dwFieldCloser.blur();
    return false;
  };  

  dwFieldPrev.onclick = function() {
    if(dwFieldQueue.selection_index > 0){
      dwFieldQueue.selection_index = dwFieldQueue.selection_index - 1;
    }else{
      dwFieldQueue.selection_index = dwFieldQueue.features.length - 1;
    }
    displayNextPreviousFeature(dwFieldQueue);
    return false;
  };  

  dwFieldNext.onclick = function() {
    if(dwFieldQueue.selection_index < dwFieldQueue.features.length - 1){
      dwFieldQueue.selection_index = dwFieldQueue.selection_index + 1;
    }else{
      dwFieldQueue.selection_index = 0;
    }
    displayNextPreviousFeature(dwFieldQueue);
    return false;
  };  

  genericCloser.onclick = function() {
    genericPointOverlay.setPosition(undefined);
    selectedLayer.getSource().clear()      // Clear the selection's source, which contains the red (selected) image tile
    genericCloser.blur();
    return false;
  };

  // const selectedDWEntitySource = new VectorSource();
  // var selectedDWFeature = new Feature();

  var clearFeatureOverlaySelection = function() {
    selectedEntitySource.removeFeature(selectedFeature);
  }
  console.log("clearFeatureOverlaySelection", clearFeatureOverlaySelection)
  const displayFeatureOverlay = function(feature: any, coordinate: any) {
    selectedFeature = feature;
    selectedEntitySource.addFeature(feature);
    selectedLayer.setSource(selectedEntitySource);
    if (feature.getGeometry().getType() === 'Point') {
      selectedLayer.setStyle(
        new Style({
          image: new Circle({
            radius: pointRadius,
            fill: null,
            stroke: new Stroke({
              color: '#f95454', // '#f95454' is a red 
              width: 2,
            }),
          }),
        }),
      );
    } else {
      selectedLayer.setStyle(
        new Style({
          fill: null,
          stroke: new Stroke({
            color: '#f95454', // Red selection (e.g. color of selected tile outline) '#f95454' is a red 
            width: 2,
          }),
        }),
      );
    }

    // 2019-11-26 disabling feature property readout overlay for now
    // per woody request
    //return;
    /*console.log("feature", feature)
    var props = feature.getProperties(); // eslint-disable-line no-unreachable
    var html = '';
    for (var prop in props) {
      if (prop !== 'geometry' && (props[prop] || props[prop] === 0)) {
        let value = props[prop];
        if (isFloat(value) && value.toFixed) {
          value = value.toFixed(2);
        }
        html += `<p><b>${prop}:</b> ${value}</p>`;
      }
    }
    content.innerHTML = html;
    infoOverlay.setPosition(coordinate);
    */
  };  
  
  const prepareDWLayerOverlay = function(feature: any, coordinate: any) {
    var additionalFeatures:any = null;
    var addressFeatures:any = null;
    // If there is a contact id on the object, query for it and create tabbed popup 
    console.log("prepareDWLayerOverlay: ", feature, coordinate)
    if ((feature.getProperties().properties["Start customer facility_id"])||(feature.getProperties().properties["End customer facility_id"])||(feature.getProperties().properties["id"])){
      console.log('id: ', feature.getProperties().properties["id"]);
      console.log('Start customer facility_id: ', feature.getProperties().properties["Start customer facility_id"]);
      console.log('End customer facility_id: ', feature.getProperties().properties["End customer facility_id"]);
      additionalFeatures = null;
      addressFeatures = null;
      let contactComplete = false;
      let addressComplete = false;
      var dataIn = {
        entity_id: null //"90053" // "90954" //_entityId  // "90013"
      }
      if (feature.getProperties().properties["Start customer facility_id"]){
        dataIn.entity_id = (feature.getProperties().properties["Start customer facility_id"]).toString()
      }
      if (feature.getProperties().properties["End customer facility_id"]){
        dataIn.entity_id = (feature.getProperties().properties["End customer facility_id"]).toString()
      }      
      if (feature.getProperties().properties["id"]){
        dataIn.entity_id = (feature.getProperties().properties["id"]).toString()
      }
      console.log('Querying on this id:', dataIn.entity_id);
      queryConnection.query({
        query: GET_DW_ENTITY_CONTACT, // GET_DW_ENTITY_ADDRESSES,
        variables: dataIn,
        optimisticResponse: null
      })
      .then((result: any) => {
          contactComplete = true;
          console.log("Query result: ", result)
          console.log("Query result contact content: ", result.data.syncarto_dw_entity_contact)
          additionalFeatures = result;
          if (additionalFeatures.data.syncarto_dw_entity_contact.length <= 0){
            additionalFeatures = null;
          }
          if (addressComplete && contactComplete){
            displayDWLayerOverlay(feature, coordinate, additionalFeatures, addressFeatures, "GraphQL Result");
          }
      })
      .catch((error: any) => {
        contactComplete = true;
        console.error(error);
        additionalFeatures = null;
        console.log("There was an error with the query:", error)
        //displayDWLayerOverlay(feature, coordinate, additionalFeatures, "GraphQL Error");
      });  

      queryConnection.query({
        query: GET_DW_ENTITY_ADDRESSES,
        variables: dataIn,
        optimisticResponse: null
      })
      .then((result: any) => {
          addressComplete = true;
          console.log("Address Query result: ", result)
          //console.log("Address Query result contact content: ", result.data.syncarto_dw_entity_contact)
          addressFeatures = result;
          
          if (addressFeatures.data.syncarto_dw_entity.length <= 0){
            addressFeatures = null;
          }
          if (addressComplete && contactComplete){
            displayDWLayerOverlay(feature, coordinate, additionalFeatures, addressFeatures, "GraphQL Result");
          }
      })
      .catch((error: any) => {
        addressComplete = true;
        console.error(error);
        addressFeatures = null;
        console.log("There was an error with the address query:", error)
        //displayDWLayerOverlay(feature, coordinate, additionalFeatures, "GraphQL Error");
      });
    }else{
      displayDWLayerOverlay(feature, coordinate, additionalFeatures, addressFeatures, "No additional features");
    }
  }

  const displayDWLayerOverlay = function(feature: any, coordinate: any, additionalFeatures: any, addressFeatures: any, caller: any, ) {
      console.log("Rendering popup. Contact features = ", additionalFeatures)
      console.log("Rendering popup. Address features = ", addressFeatures)
      //console.log("Caller: ", caller)
      selectedFeature = feature;
      //selectedDWEntitySource.addFeature(feature);
      selectedLayer.setSource(selectedEntitySource);
      if (feature.getGeometry().getType() === 'Point') {
        selectedLayer.setStyle(
          new Style({
            image: new Circle({
              radius: pointRadius,
              fill: null,
              stroke: new Stroke({
                color: '#f95454',
                width: 2,
              }),
            }),
          }),
        );
      }

    var props = feature.getProperties().properties; // eslint-disable-line no-unreachable
    var html = '';
    var addHtml = '';
    var addressHtml = '';
    for (var prop in props) {
      if (prop !== 'geometry' && (props[prop] || props[prop] === 0)) {
        if (prop !== 'feature_type') {
          let value = props[prop];
          if (isFloat(value) && value.toFixed) {
            value = value.toFixed(2);
          }
          html += `<li><b>${prop}:</b> ${value}</li>`;
        }
      }
    }
    dwTitle.innerHTML = "Data Warehouse"; // Set popup title here
    if (additionalFeatures){
      console.log("displayDWLayerOverlay", additionalFeatures.data.syncarto_dw_entity_contact)
      let addProps = additionalFeatures.data.syncarto_dw_entity_contact;
      for (var addProp in addProps) {
        let contact = addProps[addProp].contact;
        console.log("contact", contact)
        for (var value in contact) {
          if (contact[value] != null){
            console.log("value", value)
            //if (isFloat(value) && value.toFixed) {
            //  value = value.toFixed(2);
            //}
            addHtml += `<li><b>${value}:</b> ${contact[value]}</li>`;
          }
        }
      }
      if (!dwContent.classList.contains("ol-popup-content-off")){
        dwContent.classList.add("ol-popup-content-off")
      }
      dwTabContent.classList.remove("ol-popup-content-off")
      dwTabContentInfo.innerHTML = '<ul>' + html + '</ul>';
      dwTabContentContact.innerHTML = '<ul>' + addHtml + '</ul>';
    }else{
      if (!dwTabContent.classList.contains("ol-popup-content-off")){
        dwTabContent.classList.add("ol-popup-content-off")
      }
      dwContent.classList.remove("ol-popup-content-off")
      dwContent.innerHTML = '<ul>' + html + '</ul>';
    }    
    if (addressFeatures){
      console.log("displayDWLayerOverlay", addressFeatures.data.syncarto_dw_entity)
      let addPropsAddress = addressFeatures.data.syncarto_dw_entity;
      for (var addPropAddress in addPropsAddress) {
        let addressIn = addPropsAddress[addPropAddress].address;
        console.log("Address", addressIn)
        for (var value in addressIn) {
          if (addressIn[value] != null){
            console.log("value", value)
            //if (isFloat(value) && value.toFixed) {
            //  value = value.toFixed(2);
            //}
            addressHtml += `<li><b>${value}:</b> ${addressIn[value]}</li>`;
          }
        }
      }
      if (!dwContent.classList.contains("ol-popup-content-off")){
        dwContent.classList.add("ol-popup-content-off")
      }
      dwTabContent.classList.remove("ol-popup-content-off")
      dwTabContentInfo.innerHTML = '<ul>' + html + '</ul>';
      dwTabContentAddress.innerHTML = '<ul>' + addressHtml + '</ul>';
    }else{
      if (!dwTabContent.classList.contains("ol-popup-content-off")){
        dwTabContent.classList.add("ol-popup-content-off")
      }
      dwContent.classList.remove("ol-popup-content-off")
      dwContent.innerHTML = '<ul>' + html + '</ul>';
    }
    dwPointOverlay.setPosition(coordinate);

  };
  
  const getContactInfo = function(_entityId: string) {
      //console.log("QUERY FOR CONTACTS")
      //console.log("queryConnection: ", queryConnection)
      //console.log("GET_DW_ENTITY_CONTACT: ", GET_DW_ENTITY_CONTACT)
      let dataIn = {
        entity_id: "90053" // "90954" //_entityId  // "90013"
      }
      queryConnection.query({
        query: GET_DW_ENTITY_CONTACT,
        variables: dataIn,
        optimisticResponse: null
      })
      .then((result: any) => {
          console.log("contact query result", result)
          return result;
      })
      .catch((error: any) => {
        console.error(error);
        return [];
      });
  }

  const displayParcelLayerOverlay = function(feature: any, coordinate: any) {
    selectedFeature = feature;

    var props = feature.getProperties(); // eslint-disable-line no-unreachable
    var html = '';
    for (var prop in props) {
      //console.log(prop)
      if (prop !== 'geometry' && (props[prop] || props[prop] === 0)) {
        if (prop !== 'feature_type') {
          let value = props[prop];
          if (isFloat(value) && value.toFixed) {
            value = value.toFixed(2);
          }
          html += `<li><b>${prop}:</b> ${value}</li>`;
        }
      }
    }
    dwTitle.innerHTML = "Parcel Feature"; // Set popup title here
    dwContent.innerHTML = '<ul>' + html + '</ul>';
    dwPointOverlay.setPosition(coordinate);

  };  

  const displayFieldsLayerOverlay = function(feature: any, coordinate: any, layer: any, clickedFieldFeatures: any) {
    console.log("012122 feature", feature);
    console.log("012122 clickedFieldFeatures", clickedFieldFeatures);
    selectedLayer.getSource().clear();
    selectedFeature = feature;
    dwFieldQueue["features"] = clickedFieldFeatures;
    dwFieldQueue["selection_index"] = 0;
    
    displayNextPreviousFeature(dwFieldQueue);
    dwFieldOverlay.setPosition(coordinate);
  }
  const displayNextPreviousFeature = function(_dwFieldQueue: any) {
    console.log("012122 _dwFieldQueue", _dwFieldQueue)
    var feature = _dwFieldQueue.features[_dwFieldQueue.selection_index].feature;
    var layer = _dwFieldQueue.features[_dwFieldQueue.selection_index].layer;
    if (_dwFieldQueue.features.length <= 1){
      dwFieldOf.classList.add("ol-popup-content-off")
      dwFieldPrev.classList.add("ol-popup-content-off")
      dwFieldNext.classList.add("ol-popup-content-off")
    }else{
      dwFieldOf.classList.remove("ol-popup-content-off")
      dwFieldPrev.classList.remove("ol-popup-content-off")
      dwFieldNext.classList.remove("ol-popup-content-off")
      dwFieldOf.innerText = `${ _dwFieldQueue.selection_index + 1} of ${_dwFieldQueue.features.length}`;
    }
    
    var props = feature.getProperties(); // eslint-disable-line no-unreachable
    var html = '';
    for (var prop in props) {
      //console.log(prop)
      if (prop !== 'geometry') {
        if (prop !== 'stat_by_time') {
          let value = props[prop];
          if (isFloat(value) && value.toFixed) {
            value = value.toFixed(2);
          }
          html += `<li><b>${prop}:</b> ${value}</li>`;
        }else{
          let _statMetric = "";
          if(layer.dwdataQueryConfig.measure && layer.dwdataQueryConfig.measure.source.item) {
            if(isStats(layer.dwdataQueryConfig.measure.source.item)) {
              _statMetric = `${layer.dwdataQueryConfig.measure.source.item!.name}_${layer.dwdataQueryConfig.measure.source.sub}`;
            } else {
              _statMetric = `${layer.dwdataQueryConfig.measure.source.item!.name}_${layer.dwdataQueryConfig.measure.aggregation}`;
            }
          }
        } 
      }
    }

    dwFieldTitle.innerHTML = `${layer.values_.title}`; // Set popup title here
    dwFieldContent.innerHTML = '<ul>' + html + '</ul>';
  };  

  const displayGenericOverlay = function(props: any, coordinate: any) {
    var html = '';
    for (var prop in props) {
      console.log(prop)
          let value = props[prop];
          if (isFloat(value) && value.toFixed) {
            value = value.toFixed(2);
          }
          html += `<li><b>${prop}:</b> ${value}</li>`;
      }
    genericTitle.innerHTML = "Feature"; // Set popup title here
    genericContent.innerHTML = '<ul>' + html + '</ul>';
    genericPointOverlay.setPosition(coordinate);
  };

  // more copy pasted from https://openlayers.org/en/latest/examples/vector-esri.html
  var displayFeatureInfo = function(coordinate: any, pixel: any) {
    console.log("activeTool", activeTool)
    var lockOut = false;
    if (activeTool !== "aoi edit"){
      var clickedFieldFeatures:any = [];
      map.forEachFeatureAtPixel(pixel, function(feature:any, layer:any) {
        if ("field_name" in feature.getProperties()){
          clickedFieldFeatures.push({"feature":feature,"layer":layer});
        }
      });
      map.forEachFeatureAtPixel(pixel, function(feature: any, layer:any) {
        if (feature.getProperties()) {
          console.log('feature at coord: ', feature.getProperties());
          if ("feature_type" in feature.getProperties()){
            switch(feature.getProperties()["feature_type"]) {
              case 'data warehouse point':
                console.log('Data Warehouse Point: ', feature.getProperties());
                 /*var additionalFeatures:any = null;
                if (feature.getProperties().properties["id"]){
                  console.log('start-customer-facility_id: ', feature.getProperties().properties["id"]);
                  additionalFeatures = getContactInfo(feature.getProperties().properties["id"]);
                }else{
                 
                  if (feature.getProperties().properties["end-customer-facility_id"]){
                    console.log('end-customer-facility_id: ', feature.getProperties().properties["end-customer-facility_id"]);
                    getContactInfo(feature.getProperties().properties["end-customer-facility_id"]);
                  }
                }*/
                if (!lockOut){
                  prepareDWLayerOverlay(feature, coordinate);
                  lockOut = true;
                }
                break;              
              case 'parcel polygon':
                console.log('Data Warehouse Point: ', feature.getProperties());
                console.log("feature id ", feature.values_.properties["start-customer-facility_id"])
                displayParcelLayerOverlay(feature, coordinate);
                break;
              default:
                console.log('Default feature: ', feature.getProperties());
                break;
            }
          }else{
            console.log("012122 in feature.getProperties()", feature.getProperties())
            if ("field_name" in feature.getProperties()){
              displayFieldsLayerOverlay(feature, coordinate, layer, clickedFieldFeatures);
            }else{
              displayGenericOverlay(feature.getProperties(), coordinate);
              console.log('Feature with no info popup: ', feature.getProperties());
            }
          }
        }
        // this doesn't really handle case where there are actually >1 features
        // at this pixel, but that shouldn't really happen
        if (feature.getProperties && feature.getProperties().id) {
          console.log("clearing selectedLayer's source")
          //selectedLayer.getSource().clear()      // Clear the selection's source, which contains the red (selected) image tile
          displayFeatureOverlay(feature, coordinate);
          if (!feature.getProperties().assets) { // don't send chart message for tileOutlines features
            console.log(feature)
            const entityId = feature.getProperties().id;
            socket.emit('chart', {
              command: 'selectEntity',
              entityId,
            });
          }
        }
      });

      // loop over features again to build list of download links for any tileOutlines features
      // covering the clicked point
      let finalHtml = '';
      map.forEachFeatureAtPixel(pixel, function(feature: any) {
        if (feature.getProperties() && feature.getProperties().assets) {
          const assets = feature.getProperties().assets;
          let html = '';
          // LINE #1 
          // Add .id value as the title to each item
          if (feature.id_ && assets.visual && assets.visual.href){
            html += `<a class="tile-info-a" href="${assets.visual.href}"><i class="fa-fw fas fa-file-download"></i> ${feature.id_}</a></br>`;
          }

          // LINE #2
          const imageDate = feature.getProperties().datetime;
          //const imageDate = "2013-07-11T03:00:30Z" // This is (e.g.) the string format stored at feature.getProperties().datetime. Use this string for testing
          const imageDateObject = new Date(imageDate)
          // For reinstating full date --> const _date = imageDateObject.getDay() + "-" + imageDateObject.getMonth() + "-" + imageDateObject.getFullYear()
          const _date = imageDateObject.getFullYear()

          // Handle time element, if it exists.
          var _time = "";
          if (imageDate.split("T")[1] !== "00:00:00Z"){ // If time value is voided then only prepare date
            _time = " at " + imageDate.split("T")[1].replace("Z","");
          }

          // Make date/time link to image
          if (assets.visual && assets.visual.href) { // Display image link titled with date/time 
            html += `<span class="tile-info-span"><a class="tile-info-b" href="${assets.visual.href}"><i class="fa-fw fas fa-calendar"></i> ${_date + _time}</a>`;
          } 
          
          // Add metdata if it exists         
          if (assets.metadata && assets.metadata.href) { 
              html += ` <a class="tile-info-b" href="${assets.metadata.href}"><i class="fa-fw fas fa-bookmark"></i> Metadata</a></span>`; // ${assets.metadata.title ? assets.metadata.title : "Metadata"}
          }else{
              html += `</span>`;
          }
          if (html !== ''){
            // Wrap everything up in li for the popup
            finalHtml += `<li class="tile-info-li">` + html + `</li>`;
          }
        }
      });
      if (finalHtml) {
        content.innerHTML = `<ul class="tile-info-ul">${finalHtml}</ul>`;
        infoOverlay.setPosition(coordinate);
      }
    }
  };

  var currZoom = map.getView().getZoom();
  map.on('moveend', function(e:any) {
    var newZoom = map.getView().getZoom();
    if (currZoom !== newZoom) {
      console.log('zoom end, new zoom: ' + newZoom);
      currZoom = newZoom;
    }
  });

  map.on('singleclick', function(evt: any) {
    displayFeatureInfo(evt.coordinate, evt.pixel);
  });
  // end more copy paste from vector-esri

  // Create vector source and the feature to it.
  var vectorSource = new VectorSource();  // for AOI rectangle

  // Create vector layer attached to the vector source.
  // For AOI rectangle
  var aoiVectorLayer = new VectorLayer({
    source: vectorSource,
    style: new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.0)'
      }),
      stroke: new Stroke({
        color: '#ffcc33',
        width: 2
      })
    }),
    zIndex: 75,
  });

  // vector layer for drag box used in map/graph cross filtering
  var dragBoxVectorSource = new VectorSource();
  var dragBoxVectorLayer = new VectorLayer({
    source: dragBoxVectorSource,
    style: new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.0)'
      }),
      stroke: new Stroke({
        color: '#ff0000',
        width: 2
      })
    }),
    zIndex: 75,
  });

  // map/graph cross filter drag box interaction
  const dragBox = new DragBox({
    condition: altKeyOnly,
  });
  dragBox.on('boxend', () => {
    // see e.g. https://openlayers.org/en/latest/examples/box-selection.html

    // show a box on the map
    const extent3857 = dragBox.getGeometry().getExtent();
    const dragBoxPolygon = fromExtent(extent3857);
    const dragBoxFeature = new Feature(dragBoxPolygon);
    dragBoxVectorSource.clear();
    dragBoxVectorSource.addFeature(dragBoxFeature);

    // notify the graphs
    const extent4326 = transformExtent(extent3857, 'EPSG:3857', 'EPSG:4326');
    // console.log('DragBoxEvent', extent4326);
    const [minx, miny, maxx, maxy] = extent4326;
    socket.emit('chart', {
      command: 'mapSelect',
      minx,
      miny,
      maxx,
      maxy,
    });
  });
  map.addInteraction(dragBox);

  // vector layer for showing tile outlines to give link for full tile download
  var tileOutlinesSource = new VectorSource();
  const tileOutlinesLayer = new VectorLayer({
    zIndex: 102,
    source: tileOutlinesSource,
    style: new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.0)' // Arbitrary color with 0 opacity
      }),
      stroke: new Stroke({
        color: '#69cf75', // Green stroke for tile outline
        width: 2,
      })
    })
  });

  // Add the vector layer to the map.
  map.addLayer(aoiVectorLayer);
  map.addLayer(selectedLayer);
  map.addLayer(selectedParcelLayer);
  map.addLayer(dragBoxVectorLayer);
  map.addLayer(tileOutlinesLayer);
  return [aoiVectorLayer, selectedLayer, selectedParcelLayer, dragBoxVectorLayer, displayFeatureOverlay, dragBox, tileOutlinesLayer, tileOutlinesSource, infoOverlay];
}

var select: any;
var modify: any;
var snap: any;

var activeAOIModification = false;
var onPageLoadContext = true;

function initMapSocketSync(
  socket: SocketIOClient.Socket, // 1
  map: any, // 2
  mapView: any, // 3
  serverUrl: string, // 4
  aoiVectorLayer: any, // 5
  selectedLayer: any, // 6 
  selectedParcelLayer: any, // 7 
  tileOutlinesLayer: any, // 8
  addRemoveComponentLayer: any, // 9
  handleLayerAddRemoveDataWarehouse: any, // 10
  updateAOIQuery: any, // 11
  handleLayerAddRemoveService: any, // 12
) {
    select = new Select({ // https://openlayers.org/en/latest/apidoc/module-ol_interaction_Select-Select.html
      layers: [aoiVectorLayer] // Make only the AOI layer selectable. 
    }); 
  select.on('select',function(e:any){
    console.log("select > e", e);
    if (!activeAOIModification){
      activeAOIModification = true;
    }else{
      select.getFeatures().clear();
      activeAOIModification = false;
    }
  });  

  modify = new Modify({ // https://openlayers.org/en/latest/apidoc/module-ol_interaction_Modify-Modify.html
    features: select.getFeatures(),
    style: new Style({
      /*fill: new Fill({
        color: 'rgba(255, 255, 255, 0.2)'
      }),
      stroke: new Stroke({
        color: '#ffcc33',
        width: 2
      }),*/
      image: new Circle({
        radius: 7,
        fill: new Fill({
          color: '#ffcc33'
        })
      })
    })
  });

  modify.on('modifystart',function(e:any){
    console.log("modifystart");
    //console.log(select);
    //console.log(modify);
  });

  modify.on('modifyend',function(e:any){
    console.log("modifyend");
    //console.log(select);
    //console.log(modify);
  });
  console.log("Selected features: ", select.getFeatures())
  snap = new Snap({features: select.getFeatures()});

  const moveEndHandler = (event: any) => {
    //get current map state
    var mapParams = {
      command: 'move',
      data: {
        center: mapView.getCenter(),
        zoom: mapView.getZoom(),
        latLonExtent: transformExtent(mapView.calculateExtent(map.getSize()),'EPSG:3857','EPSG:4326'), // [minx, miny, maxx, maxy]
      },
      caller:"moveEndHandler()"
    }
    console.log('moveend event: ', event, mapParams);
    if (map.justInitialized){
      if (map.justInitialized === "yes"){
        // dont broadcast/emit the extent, we dont want to overwrite other session's extents 
        map.justInitialized = "no";
      }else{
        socket.emit('map', {
          command: 'setSessionExtent',
          data: mapParams.data
         });
         socket.emit('map', mapParams);
         map["justInitialized"] = "no"
      }
    }else{
        map["justInitialized"] = "no"
    }
  };

  let moveEndKey: any;

  socket.on('map', async function(msgobj: any){
    console.log("socket.on 'map'", msgobj);
    const gj = new GeoJSON();
    switch(msgobj.command) {
      case 'fitBounds':
        console.log("entered the fitBounds condition. msgobj --> ", msgobj);
        //console.log("map ", map);
        if (msgobj.data && msgobj.data.length){

          let _aoi_bbox = [msgobj.data[2],msgobj.data[0],msgobj.data[3],msgobj.data[1]]
          map['aoi_bbox'] = _aoi_bbox; //transformExtent(extent,'EPSG:3857','EPSG:4326');
          updateAOIQuery("mapInit > 'fitBounds'")

          var bbox =
            [
              fromLonLat([parseFloat(msgobj.data[2]), parseFloat(msgobj.data[0])]),
              fromLonLat([parseFloat(msgobj.data[3]), parseFloat(msgobj.data[0])]),
              fromLonLat([parseFloat(msgobj.data[3]), parseFloat(msgobj.data[1])]),
              fromLonLat([parseFloat(msgobj.data[2]), parseFloat(msgobj.data[1])]),
              fromLonLat([parseFloat(msgobj.data[2]), parseFloat(msgobj.data[0])])
            ];

          var polygon = new Polygon([ bbox ]);

          // Create feature with polygon.
          var feature = new Feature(polygon);
          var vectorSource = new VectorSource();

          vectorSource.addFeature(feature);
          aoiVectorLayer.setSource(vectorSource);

          // Display the AOI button (an AOI should exist if executing this case)
          var editAOIButton = document.querySelector('.edit-aoi-button')
          var deleteAOIButton = document.querySelector('.delete-aoi-button')
          if (editAOIButton && deleteAOIButton){ // avoid "Object is possibly 'null'." error 
            editAOIButton.classList.remove('edit-aoi-button-toggle-hidden');
            deleteAOIButton.classList.remove('delete-aoi-button-toggle-hidden');
          }
          /*
          if (msgobj.mapExtentToUse === "DBExtent"){ // DBExtent = loading map from database/dashboard (not config/session)
            mapView.fit(vectorSource.getExtent()); 
          }
          */   

          mapView.fit(vectorSource.getExtent()); 
          //Message object coordinates are formatted in different order than OL, reorganize before writing to aoi_bbox:
          
          if (msgobj.feature) {
            // Remove the layer from TOC if it already exists
            map.getLayers().getArray().forEach((layer: any) => {
              //console.log("layer", layer.get('title'))
              if (layer.get('title') === "Parcel Search"){
                addRemoveComponentLayer(layer,true,false,"2080");
              }
            })
            //addRemoveComponentLayer(selectedParcelLayer,true,onPageLoadContext);

            msgobj.feature.properties["feature_type"] = "parcel polygon";
            // in the case of zooming to parcel search result,
            // we also want to highlight the parcel geometry
            var selectedParcelFeature = gj.readFeature(
              msgobj.feature,
              {
                dataProjection: 'EPSG:4326',
                featureProjection: 'EPSG:3857',
              },
            );
            
            var selectedParcelSource = new VectorSource();
            selectedParcelSource.addFeature(selectedParcelFeature);
            selectedParcelLayer.setSource(selectedParcelSource);
            var parcelTitle = "Parcel Search";
            /*
            if ( selectedParcelFeature.values_.STAND_SITEADRESS ){
              parcelTitle = "Parcel at " + selectedParcelFeature.values_.STAND_SITEADRESS
            }
            */
            selectedParcelLayer.set('title',  parcelTitle);
            
            // Remove the layer from TOC if it already exists
            addRemoveComponentLayer(selectedParcelLayer,false,onPageLoadContext, "2180");
          }
        }
        break;
      case 'tileOutlines':
        console.log('got tileOutlines', tileOutlinesLayer, msgobj.featureCollection);
        if (!msgobj.featureCollection) {
          console.warn('tileOutlines feature collection is null');
          return;
        }
        const tileOutlinesFeatures = gj.readFeatures(
          msgobj.featureCollection,
          {
            dataProjection: 'EPSG:4326',
            featureProjection: 'EPSG:3857',
          },
        );
        const tileOutlinesSource = new VectorSource();

        tileOutlinesSource.addFeatures(tileOutlinesFeatures);
        tileOutlinesLayer.setSource(tileOutlinesSource);
        break;
              
        
      case 'clearAOI':
        doClearAOI(map, socket, aoiVectorLayer,"voice", updateAOIQuery);
        break;
      case 'export image':
        handleMapPrintClick("png", map, "export image case");
        break;
      case 'export PNG': // handle capitalization variations
      case 'export png':
        handleMapPrintClick("png", map, "export png case");
        break;
      /* For exposing the png and pdf export buttons, removed for now
      case 'export PDF': // handle capitalization variations
      case 'export pdf':
        handleMapPrintClick("pdf", map, "export pdf case");
        break;
      */   
      case 'update':
        const cogUrl = msgobj.data;
        console.log("about to addTileLayerFromCogUrl() msgobj", msgobj)
        const layer = await addTileLayerFromCogUrl(map, cogUrl, "Analysis"); // <-- original handling function uses https://github.com/mhiley/cog-explorer.git#for-react-build - which is not supported under the present OL version 6.5.0
        console.log("resulting 'update' layer", layer)
        addRemoveComponentLayer(layer,false,false,"update message"); 
        break;
      case 'zoom in':
      case 'enhance':
        mapView.setZoom(mapView.getZoom() + 1);
        break;
      case 'zoom out':
        mapView.setZoom(mapView.getZoom() - 1);
        break;
      case 'go right':
      case 'pan right':
      case 'pan east':
      case 'go east':
        mapView.setCenter(panBy([200, 0]));
        break;
      case 'go up':
      case 'pan up':
      case 'pan north':
      case 'go north':
        mapView.setCenter(panBy([0, -200]));
        break;
      case 'pan down':
      case 'go down':
      case 'pan south':
      case 'go south':
        mapView.setCenter(panBy([0, 200]));
        break;
      case 'go left':
      case 'pan left':
      case 'pan west':
      case 'go west':
        mapView.setCenter(panBy([-200, 0]));
        break;
      case 'edit':
        doEditMap(select, modify, snap, map, aoiVectorLayer, socket, updateAOIQuery);
        break;
      case 'save':
        doSaveMap(select, modify, snap, map, aoiVectorLayer, socket, updateAOIQuery)
        break;
      case 'use extent':
        doUseMapExtent(map, socket, aoiVectorLayer, updateAOIQuery);
        break;
      case 'move':
        // Use an alert for testing since move events hapen so quickly
        // alert("Move happening " + msgobj.caller)

        // disable the move handler; only user initiated pan/zoom should
        // cause the websockets event to get emitted.
        // (don't want to rebroadcast a move that was initiated by a broadcasted move;
        //  only want to broadcast user actions).
        // map.un('moveend', moveEndHandler);
        unByKey(moveEndKey);

        console.log('got move from websockets', msgobj.data);
        mapView.setCenter(msgobj.data.center);
        mapView.setZoom(msgobj.data.zoom);

        // re-enable websockets broadcast of pan/zoom after render is complete
        // (can't reenable moveend listener as soon as setCenter/setZoom return!)
        map.once('rendercomplete', function() {
          // console.log('rendercomplete');
          moveEndKey = map.on('moveend', moveEndHandler);
        });
        break;
      case 'addDataWarehouse':
        console.log("addDataWarehouse > msgobj", msgobj)
        break;
      case 'layerNameChange':
        console.log("layerNameChange", msgobj);
        var mapTitles: any = [];
        var msgTitles: any = [];
        // Push all map titles into array
        map.getLayers().getArray().forEach((layer: any) => {
          //console.log("layer", layer)
          const layerTitle = layer.get('title');
          if (layerTitle) {
            if ((layerTitle !== "Basemap") && (layerTitle !== "Statistics")) {
              mapTitles.push(layerTitle);
            }
          }
        });
        // Push all message titles into array
        const msgLayers = msgobj.layers;
        for (const msgLayer of msgLayers) {
          let msgLayerTitle = msgLayer.title;
          msgTitles.push(msgLayerTitle)
        }
        for( var v = 0; v < mapTitles.length; v++){ 
          const mapTitle = mapTitles[v];
          if (mapTitle) {
            for( var i = 0; i < msgTitles.length; i++){ 
              const msgTitle = msgTitles[i];
              if (msgTitle){
                if (msgTitle === mapTitle){
                  //console.log("msgTitle === mapTitle", msgTitle, mapTitle)
                  msgTitles[i] = "";
                  mapTitles[v] = "";
                }
              }
            }
          }
        };
        var msgTo = "";
        var mapFrom = "";
        for( var j = 0; j < msgTitles.length; j++){ if( msgTitles[j] !== ""){( msgTo = msgTitles[j] )}}
        for( var k = 0; k < mapTitles.length; k++){ if( mapTitles[k] !== ""){( mapFrom = mapTitles[k] )}}

        console.log("mapTitles", mapTitles);
        console.log("msgTitles", msgTitles);
        console.log("mapFrom", mapFrom);
        console.log("msgTo", msgTo);

        map.getLayers().getArray().forEach((layer: any) => {
          const layerTitle = layer.get('title');
          if (layerTitle) {
            if (layerTitle === mapFrom) {
              layer.setProperties({title:msgTo})
            }
          }
        });
        map["layerList"] = msgobj.layers;
        break;
      case 'layerChange':
        /*
        if (msgobj.caller === "database"){ // Use the layers saved to 'config' field in DB
          msgobj.layers = map.layerList
        }
        // first build up mapping between layer titles and layer objects for efficient lookup
        const layerTitleMapping: any = {};
        map.getLayers().getArray().forEach((layer: any) => {
          const layerTitle = layer.get('title');
          if (layerTitle) {
            layerTitleMapping[layerTitle] = layer;
          }
        });
        */
       console.log("layerChange > msgobj", msgobj)
       if (msgobj.dataWarehouse){
         console.log("msgobj.dataWarehouse", msgobj.dataWarehouse)
       }else{
         if (msgobj.caller === "database"){ // Use the layers saved to 'config' field in DB, if (msgobj.caller === "session") then the msgobj.layers are already set (from chatbot)
          console.log("assigning msgobj.layers",msgobj.layers,"with map.layerList", map.layerList) 
          map["layersLoadedFrom"] = ["database", false];
          map["layerListOnLoad"] = map.layerList
          msgobj.layers = map.layerList
         }else{
          console.log("assigning map.layerList", map.layerList,"with msgobj.layers",msgobj.layers) 
          map.layerList = msgobj.layers
          map["layersLoadedFrom"] = ["session", false];
          map["layerListOnLoad"] = msgobj.layers
         }
        // first build up mapping between layer titles and layer objects for efficient lookup
        const layerTitleMapping: any = {};
        map.getLayers().getArray().forEach((layer: any) => {
          const layerTitle = layer.get('title');
          //console.log("layerTitle", layerTitle) 
          if (layerTitle) {
            layerTitleMapping[layerTitle] = layer;
          }
        });
        console.log("layerTitleMapping", layerTitleMapping) 
        /*
        if (msgobj.deletedLayer) {
          let deletedLayer = layerTitleMapping[msgobj.deletedLayer];
          if (deletedLayer) {
            map.removeLayer(deletedLayer);
            addRemoveComponentLayer(deletedLayer, true);
          }
        }
        const msgLayers = msgobj.layers;
        // note, important not to use forEach here b/c the forEach callback would
        // be async and break the guarantee that addRemoveComponentLayer gets called in the correct order
        for (const msgLayer of msgLayers) {
          let mapLayer = layerTitleMapping[msgLayer.title];
          if (!mapLayer) {
            if (msgLayer.cogUrl) {
              mapLayer = await addTileLayerFromCogUrl(map, msgLayer.cogUrl, msgLayer.title);
            } else {
              mapLayer = await addTileLayerFromDataSource(map, serverUrl, msgLayer.dataSourceRow, msgLayer.title);
        */
          if (msgobj.deletedLayer) {
            console.log("msgobj.deletedLayer", msgobj)
            let deletedLayer = layerTitleMapping[msgobj.deletedLayer];
            if (deletedLayer) {
              map.removeLayer(deletedLayer);
              addRemoveComponentLayer(deletedLayer, true, false, "2333");        
            }
            //addRemoveComponentLayer(mapLayer,false,onPageLoadContext);
          }
          const msgLayers = msgobj.layers;
          // note, important not to use forEach here b/c the forEach callback would
          // be async and break the guarantee that addRemoveComponentLayer gets called in the correct order
          // note also that DW layers have an inherently async call to the DB, thus they may be returned out of order 
          // anyway. This is why we must build a list of the corrrect order that will then be passed to mapWidget > handleLayerOrderChange();
          //  build list
          //  call after (follow updateAOIQuery) 
          // 
          console.log("Rebuilding layers from msgLayers = ", msgLayers);
          for (const msgLayer of msgLayers) {
            //if (true){
            //if ("dataSourceRow" in msgLayer){
              console.log("msgLayer", msgLayer);
            if ("layerParams" in msgLayer){ // This is a DW layer. 
              console.log("msgLayer (DW layer or Service layer encountered)", msgLayer);
              console.log("msgobj ", msgobj);
              // This is a data warehouse layer, add it if this is being called by the "session" or the "database" upon page load only
              if ((msgobj.caller === "session")||(msgobj.caller === "database")){
                if("serviceConfig" in  msgLayer.layerParams){
                  console.log("msgLayer (Service layer encountered)", msgLayer);
                  handleLayerAddRemoveService(msgLayer, msgLayer.title, msgLayer.layerParams.layerStyle)
                }else{
                  handleLayerAddRemoveDataWarehouse(msgLayer, msgLayer.title, msgLayer.layerParams.layerStyle)
                }
              }else{
                console.log("gap in logic here ?", msgobj)
              }
            }else{
              console.log("msgLayer (tile layer encountered)", msgLayer);
              let mapLayer = layerTitleMapping[msgLayer.title];
              if (!mapLayer) {
                if (msgLayer.interpId) {
                  mapLayer = await addNRCSFromDataSource(map, msgLayer);
                }else{
                  if (msgLayer.cogUrl) {
                    console.log("msgLayer (COG layer encountered)", msgLayer)
                    mapLayer = await addTileLayerFromCogUrl(map, msgLayer.cogUrl, msgLayer.title);
                    mapLayer['title'] = msgLayer.title;
                    console.log("Created this COG mapLayer", mapLayer)
                  } else {
                    mapLayer = await addTileLayerFromDataSource(map, serverUrl, msgLayer.dataSourceRow, msgLayer.title);
                  }
                }
                addRemoveComponentLayer(mapLayer,false,onPageLoadContext,"2371");
              }
              /* 
              if (msgLayer.visible !== undefined && msgLayer.visible !== mapLayer.getVisible()) {
                mapLayer.setVisible(msgLayer.visible);
              }
              if (msgLayer.yearStart && msgLayer.yearEnd &&
                (msgLayer.yearStart !== mapLayer.get('yearStart') || msgLayer.yearEnd !== mapLayer.get('yearEnd'))) {
                mapLayer.setProperties({
                  yearStart: parseInt(msgLayer.yearStart),
                  yearEnd: parseInt(msgLayer.yearEnd),
                });
                // TODO the slider is inevitably gonna have to support actual dates;
                // when that happens we won't have to guess at the date part of string here..
                const startTime = `${msgLayer.yearStart}-01-01`;
                const endTime = `${msgLayer.yearEnd}-01-01`;
                updateTileLayerDateRange(mapLayer, startTime, endTime);
              */
              //console.log("msgLayer.visible", msgLayer.visible)
              if (msgLayer.visible !== undefined && msgLayer.visible !== mapLayer.getVisible()) {
                mapLayer.setVisible(msgLayer.visible);
              }
              //console.log("mapLayer", mapLayer)
              if (msgLayer.yearStart && msgLayer.yearEnd &&
                (msgLayer.yearStart !== mapLayer.get('yearStart') || msgLayer.yearEnd !== mapLayer.get('yearEnd'))) {
                mapLayer.setProperties({
                  yearStart: parseInt(msgLayer.yearStart),
                  yearEnd: parseInt(msgLayer.yearEnd),
                });
                // TODO the slider is inevitably gonna have to support actual dates;
                // when that happens we won't have to guess at the date part of string here..
                var startTime = `${msgLayer.yearStart}-01-01`;
                var endTime = `${msgLayer.yearEnd}-01-01`;
                if (msgLayer.dataSourceRow.date_display_resolution === "year"){
                  startTime = `${msgLayer.yearStart}-01-01`;
                  endTime = `${msgLayer.yearEnd}-01-01`;
                }
                console.log("A120621 msgLayer.yearStart", msgLayer.yearStart);
                console.log("A120621 msgLayer.yearEnd", msgLayer.yearEnd);
                if (msgLayer.dataSourceRow.date_display_resolution === "day"){
                  startTime = `${convertFromEpoch(msgLayer.yearStart)}`;
                  endTime = `${convertFromEpoch(msgLayer.yearEnd)}`;
                }
                updateTileLayerDateRange(mapLayer, startTime, endTime, 'layerChange');
              }
            }//else{
             // console.log("c) Non-tile layer encountered. Not yet supported.");
            //}
          }
          map["layerList"] = msgobj.layers;
          //console.log("Layer-DEV map['layerListOnLoad']", map["layerListOnLoad"])
          map["layerListOnLoad"] = msgobj.layers;
          //console.log("Layer-DEV map['layerListOnLoad']", map["layerListOnLoad"])
          
          console.log("Done queuing layers, map['layerList'] = ", map["layerList"]);
          console.log("Done queuing layers, msgobj.layers = ", msgobj.layers);
          onPageLoadContext = false;
          //this.emitLayerList('layerChange', layer);
          /*let params = {
            command: 'layerNameChange',
            layers: msgobj.layers,
          };
          socket.emit('map', params);*/
        }
        break;
      default:
        console.log('no matching map command', msgobj.command);
        break;
    }
  });

  moveEndKey = map.on('moveend', moveEndHandler);

  function panBy (pix: any) {
    var center = map.getPixelFromCoordinate(mapView.getCenter());
    var pan = map.getCoordinateFromPixel([center[0] + pix[0], center[1] + pix[1]]);
    return pan;
  }
  
};

function initFarmBoundaries(socket: any, map: any, addRemoveComponentLayer: any) {
  var farmBoundariesAttribution = '';
  var farmBoundariesSource = new VectorSource({
    attributions: [farmBoundariesAttribution],
  });
  var farmBoundariesLayer = new VectorLayer({
    zIndex: 102,
    source: farmBoundariesSource,
    style: new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.0)'
      }),
      stroke: new Stroke({
        color: '#f95454',
        width: 2,
      })
    })
  });
  // Re-using the farm boundaries layer as layer for result of summarization
  // TODO: refactor variable names to match this
  farmBoundariesLayer.set('title', 'Statistics');

  map.addLayer(farmBoundariesLayer);

  socket.on('boundaries', function(collection: any){
    // create a new empty source so that mapview.fit only fits the newest features
    farmBoundariesSource = new VectorSource({
      attributions: [farmBoundariesAttribution],
    });

    var features = collection.features;
    console.log(`received ${features.length} boundaries`);
    var gj = new GeoJSON();
    var featureObj = gj.readFeatures(
      collection,
      {
        dataProjection: 'EPSG:4326',
        featureProjection: 'EPSG:3857',
      },
    );

    // style the polygons according to summarized value
    featureObj.forEach(function (obj: any) {
      const minScale = -0.2;
      const maxScale = 0.7;
      const props = obj.getProperties();
      let value = props['mean'];
      const originalValue = value;

      if (value < minScale) {
        value = minScale;
      }
      if (value > maxScale) {
        value = maxScale;
      }

      // start w/ same red->green ramp as used for rendering COGs
      let red = 255 - (((value - minScale) / (maxScale - minScale)) * 255);
      let green = ((value - minScale) / (maxScale - minScale)) * 255;
      let blue = 0;

      red = Math.round(red);
      green = Math.round(green);
      blue = Math.round(blue);

      let rgba = `rgba(${red}, ${green}, ${blue}, 0.5)`;
      if (!originalValue && !(originalValue === 0.0 || originalValue === 0)) {
        // transparent if null
        rgba = 'rgba(0, 0, 0, 0)';
      }

      obj.setStyle(new Style({
        fill: new Fill({
          color: rgba
        }),
        stroke: new Stroke({
          color: '#42f4d4',
          width: 2
        })
      }));
    });

    farmBoundariesSource.addFeatures(featureObj);
    farmBoundariesLayer.setSource(farmBoundariesSource);
    // Add layer to the layer list.
    addRemoveComponentLayer(farmBoundariesLayer,false,onPageLoadContext,"2534");
    map.getView().fit(farmBoundariesSource.getExtent());
  });

  socket.on('highlightBoundaries', function(slots: any){
    // assume current property ...
    // const property = slots.property;

    const greaterThanOrLessThan = slots.operator;
    const threshold = parseFloat(slots.value);

    farmBoundariesSource.getFeatures().forEach(function(feature: any) {
      const style = feature.getStyle();
      const value = feature.getProperties()['mean']

      // default style
      let color = '#fff'; // white
      let width = 1;

      if (
        (greaterThanOrLessThan === 'less than' && value < threshold) ||
        (greaterThanOrLessThan === 'greater than' && value > threshold)
      ) {
        // "highlighted" style
        color = '#ff9e0d'; // orange
        width = 3;
      }
      style.setStroke(new Stroke({
        color: color,
        width: width,
      })
      );

      feature.setStyle(style);
    });
  });

  socket.on('NRCSOverlay', function(data: any){
    console.log("data.interpId", data.interpId)
    var NRCSlayer = new ImageLayer({
      //extent: [-13884991, 2870341, -7455066, 6338219],
      source: new ImageWMS({
        url: 'https://SDMDataAccess.sc.egov.usda.gov/Spatial/SDM.wms',
        params: {
          'VERSION': '1.1.1',
          'LAYERS': 'mapunitpolythematic,aoilabeled',
          // 'aoiid': data.aoiId,
          // 'sld_id': data.sldId,
          'INTERPRESULTID': data.interpId
        }
      })
    });
    NRCSlayer["interpId"] = data.interpId;
    NRCSlayer.setZIndex(200);
    map.addLayer(NRCSlayer);
    let enumerateNRCS = 1;
    map.getLayers().getArray().forEach((layer: any) => {
      if (layer.get('title')){
        const existingNRCSTitle = layer.get('title');
        if (existingNRCSTitle.includes("NRCS")){
          enumerateNRCS++;
        }
      }
    });
    let NRCSTitle = 'NRCS';
    if (enumerateNRCS > 1){
      NRCSTitle = 'NRCS ' + enumerateNRCS.toString()
    }
    NRCSlayer.set('title', NRCSTitle);
    addRemoveComponentLayer(NRCSlayer,false,onPageLoadContext,"2603");
  });
};

/**
 * Creates openlayers map in the given element
 * @param {string} sessionId
 * @param {string} serverUrl
 * @param {HTMLElement} el
 */
function createMapObject(el : HTMLElement, _config:any) {
  const mapEl: any = el.querySelector('#map');
  let configObject = {
    mapCenter: { // Somewhere over Lake Winnebago, for now. 
      lat: 44.106,
      lng: -88.402,
      zoomLevel: 10
    },
    layersFromTop:[]
  };
  if (_config){
    configObject = JSON.parse(_config)
    console.log("configObject,", configObject)
  }

  if (mapEl.querySelector('.ol-viewport')) {
    return;
  }

  var mapView = new View({
    center: fromLonLat([configObject.mapCenter.lng, configObject.mapCenter.lat]),
    zoom: configObject.mapCenter.zoomLevel
  });

  var map = new Map({
    //renderer: 'webgl',
    controls: defaultControls({
      attributionOptions: {
        collapsible: false
      }
    }),
    target: mapEl,
    layers: [
      new TileLayer({
        source: new XYZ({
          crossOrigin: 'anonymous',
          attributions: 'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/' +
          'rest/services/ESRI_Imagery_World_2D/MapServer">ArcGIS</a>',
          url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' +
          'World_Topo_Map/MapServer/tile/{z}/{y}/{x}'
        }),
        title: 'Basemap',
      })
    ],
    view: mapView,
  });
  map["justInitialized"] = "yes"
  map["layerList"] = configObject.layersFromTop;
  console.log("map['layerListOnLoad']", map["layerListOnLoad"])
  map["layerListOnLoad"] = configObject.layersFromTop;
  console.log("map['layerListOnLoad']", map["layerListOnLoad"])
  return map;
}

function getTileUrlTemplate(row:any, stacUrl: string, collectionId: string, footprintProperty: string, startTime: string, endTime: string, dateDisplayResolution:string, _caller:string = "unknown") {
  const stacUrlEnc = encodeURIComponent(stacUrl);
  const collectionIdEnc = encodeURIComponent(collectionId);
  const footprintEnc = encodeURIComponent(footprintProperty);
  console.log("A120621 _caller", _caller);
  console.log("A120621 startTime", startTime);
  console.log("A120621 endTime", endTime);
  console.log("120621 row.min_date", row.min_date);
  console.log("120621 row.max_date", row.max_date);
  console.log("120621 row.date_display_resolution", row.date_display_resolution);
  console.log("120621 row", row);
  // HACK add a day to max date / subtract a day from min date;
  // prevents off by one error in the time filter due to only storing a date
  // on syncarto_app.data_source
  // TODO probably need to make min_date/max_date a full timestamp
  var minDateFudged = startTime; //new Date(startTime).toISOString().split('T')[0];
  var maxDateFudged = endTime; //new Date(endTime).toISOString().split('T')[0];
  if (dateDisplayResolution === 'year'){
    minDateFudged = new Date((new Date(startTime)).valueOf() - 24*3600*1000).toISOString().split('T')[0]
    // FORMER LOGIC, does not sufficiently cover whole year, e.g., 2020-01-01 would not allow for any days other than Jan 1 to be queried for 2020,
    // even though the slider will display 2020 and would lead user to believe they are isolating ALL of 2020. 
    //const maxDateFudged = new Date((new Date(endTime)).valueOf() + 24*3600*1000).toISOString().split('T')[0]
    // NEW LOGIC, modify max date so that it always ends on the last day of the year.
    maxDateFudged = `${new Date(endTime).getUTCFullYear()}-12-31`; 
  }
  if (dateDisplayResolution === 'day'){
    //minDateFudged = new Date(startTime).toISOString().split('T')[0];
    //maxDateFudged= new Date(endTime).toISOString().split('T')[0];
    var minDate2:any = new Date(startTime);
    var maxDate2:any = new Date(endTime);
    console.log("120621 minDate2", minDate2);
    console.log("120621 maxDate2", maxDate2);
    var minDaysSinceEpoch2 = Math.floor(minDate2/8.64e7) - 2;
    var maxDaysSinceEpoch2 = Math.floor(maxDate2/8.64e7) + 2;
    console.log("120621 minDaysSinceEpoch2", minDaysSinceEpoch2);
    console.log("120621 maxDaysSinceEpoch2", maxDaysSinceEpoch2);
    minDateFudged = convertFromEpoch(minDaysSinceEpoch2);
    maxDateFudged = convertFromEpoch(maxDaysSinceEpoch2);
  }
  console.log("120621 minDateFudged", minDateFudged);
  console.log("120621 maxDateFudged", maxDateFudged);
  const timeRange = encodeURIComponent(`${minDateFudged}/${maxDateFudged}`);
  console.log("120621 timeRange", timeRange);
  let _colorRamp = row.color_ramp ? (`&color_ramp=` + encodeURIComponent(row.color_ramp)) : ``;
  let _colorMap = row.color_map ? (`&color_map=` + encodeURIComponent(row.color_map)) : ``;
  let _stacQueryPrefix = row.stac_query_prefix;
  let _tileServer = row.tile_server;
  let _jq = row.jq ? (`&jq=` + encodeURIComponent(row.jq)) : ``;
  let _globalMin = row.global_min ? (`&global_min=` + encodeURIComponent(row.global_min)) : ``;
  let _globalMax = row.global_max ? (`&global_max=` + encodeURIComponent(row.global_max)) : ``;
  let _expr = row.expr ? (`&expr=` + encodeURIComponent(row.expr)) : ``;

  let _wroc = ["wroc-2010","wroc-2015","wroc-2020","wroc-combined","wroc-overviews","wroc-overviews-2","wroc-test-2"]
  if (collectionId === 'NAIP') {
    // NAIP is special case for now- until I re-index with consistent collection id, need to search by constellation property.
    // Also need to change footprint property name to "footprint_id"
    return `https://tiles-{a-f}.syncarto.com/stac/{z}/{x}/{y}?url=${stacUrlEnc}&constellation=NAIP&footprintProperties=naip%3Aquarter_quad_id&time=${timeRange}`;
  } else {
    console.log("Template for non-NAIP layer, row", row)
    if (collectionId in _wroc) {
      return `https://tiles-{a-f}.syncarto.com/stac/{z}/{x}/{y}?url=${stacUrlEnc}&collection=${collectionIdEnc}&footprintProperties=${footprintEnc}&time=${timeRange}`;
    }else{
      // TARGET:
      // https://tiles-docker-test.syncarto.com/stac/11/342/797?url=https://stac-server.syncarto.com/search&color_ramp=[[0,"#000000"],[0.125,"#FF0000"],[0.5,"#FFFF00"],[0.75,"#00c800"],[1,"#0000FF"]]&datetime=2021-08-01/2021-08-10&collections=fd8ce854-9f8e-11ea-a22c-02a6f2671be5-vvi&jq=sort_by(.properties.datetime)|reverse|group_by(.properties["sentinel:tileId"])|map(.[0])&global_min=1200&global_max=20000&expr=(data[0]-1200)/(20000-1200)
      return `${_tileServer}/stac/{z}/{x}/{y}?url=${stacUrlEnc}${_colorRamp}${_colorMap}&datetime=${timeRange}&${_stacQueryPrefix}=${collectionIdEnc}${_jq}${_globalMin}${_globalMax}${_expr}`;

    }
  }
}

function updateTileLayerDateRange(layer: any, newStartTime: string, newEndTime: string, _caller:string = "unknown") {
  // Better to set url and refresh existing source than create new source.
  // (If you create a new source, the existing tiles won't get cleared
  // before redraw, which makes it impossible to tell whether the new time
  // range selection is actually returning results or not.)
  const source = layer.getSource() as any;
  const row = layer.get('dataSourceRow');
  const newTemplate = getTileUrlTemplate(
    row,
    row.stac_address,
    row.collection_id,
    layer.get('footprintProperty'),
    newStartTime,
    newEndTime,
    row.date_display_resolution,
    "new template",
  );
  source.setUrl(newTemplate);
  source.refresh();
}

function getUniqueLayerTitle(map: any, title: any, suffix = 1): any {
  if (!title) {
    return (new Date()).valueOf();
  }

  let exists = false;
  map.getLayers().getArray().forEach((layer: any) => {
    const existingTitle = layer.get('title');
    let testTitle = title;
    if (suffix !== 1) {
      testTitle = `${title} ${suffix}`;
    }
    if (existingTitle === testTitle) {
      exists = true;
    }
  });

  if (exists) {
    return getUniqueLayerTitle(map, title, suffix + 1);
  }

  if (suffix === 1) {
    return title;
  } else {
    return `${title} ${suffix}`;
  }

}

async function addTileLayerFromCogUrl(map: any, url: string, title: any = null) {
  console.log("addTileLayerFromCogUrl map, url, title", map, url, title)
  /* old example using cog-explorer
  const adapter = new CogAdapter(map);
  const samples = 1;
  const bands = new Map();
  for (let i = 0; i < samples; ++i) {
    bands.set(i, url);
  }
  if (!title) {
    title = getUniqueLayerTitle(map, 'Analysis');
  }
  await adapter.addSceneLayer({
    id: url,
    bands: bands,
    redBand: 0,
    greenBand: 0,
    blueBand: 0,
    isSingle: true,
    hasOvr: false,
    isRGB: false,
    attribution: undefined,
    pipeline: [
      // this can be empty array, but here is example for gamma
      // see src/app.jsx for expected structure
      { operation: 'gamma',
        bands: 'all',
        value: 1.0,
      }
    ],
  }, {
    isCogAdapter: true,
    cogUrl: url,
    title,
  });
  console.log("adapter", adapter)
  const tileLayer = adapter.sceneLayers[url];
  console.log("tileLayer", tileLayer)
  //map.addLayer(tileLayer);
  return tileLayer;*/

  // An array of numbers representing an extent: [minx, miny, maxx, maxy].
  const sourceExtent = [-10180280.3468, 5605471.0646, -10178543.2432, 5607222.2909];
  console.log("sourceExtent", sourceExtent)
  let cogTileLayer = new WebGLTileLayer({
    source: new GeoTIFFSource({
      sources: [
        {
          url: url,
          min: 0,
          nodata: 0,
          max: 1
        },
      ],
    }),
    //extent: sourceExtent,
  })
  cogTileLayer.set("title", title);
  map.addLayer(cogTileLayer);
  return cogTileLayer;
}

async function addNRCSFromDataSource(map: any, row: any) {
  console.log("addNRCSFromDataSource row", row)
  if (row.interpId) {
    var title = getUniqueLayerTitle(map, row.title);
    var NRCSlayer = new ImageLayer({
      //extent: [-13884991, 2870341, -7455066, 6338219],
      source: new ImageWMS({
        url: 'https://SDMDataAccess.sc.egov.usda.gov/Spatial/SDM.wms',
        params: {
          'VERSION': '1.1.1',
          'LAYERS': 'mapunitpolythematic,aoilabeled',
          // 'aoiid': data.aoiId,
          // 'sld_id': data.sldId,
          'INTERPRESULTID': row.interpId
        }
      }),
      title
    });
    NRCSlayer["interpId"] = row.interpId;
    NRCSlayer.setZIndex(200);
    map.addLayer(NRCSlayer);
    return NRCSlayer;
  }
}

async function addTileLayerFromDataSource(map: any, serverUrl: string, row: any, title: string) {
  const mapView = map.getView();
  let token: any;
  try {
    token = await fetchJwtToken(serverUrl);
  } catch(err) {
    console.warn('failed to fetch jwt; tile layers will not load: ', err);
    return;
  }

  const tileLoadFunction = (tile: any, src: any) => {
    // this is the only way to set auth headers on tile server requests; see
    // https://openlayers.org/en/latest/apidoc/module-ol_source_XYZ-XYZ.html and
    // https://github.com/openlayers/openlayers/issues/5401
    var xhr = new XMLHttpRequest();
    xhr.open("GET", src);
    xhr.responseType = "arraybuffer";

    // Note browser will do a preflight OPTIONS request b/c we are setting custom header.
    // This initiallay caused a 500 error on the OPTIONS request. Fix was to go into
    // the marblecutter-virtual api gateway console, delete both OPTIONS resources (so
    // that the OPTIONS request goes to Lambda function), and "Deploy API".
    // see also possibly related https://github.com/awslabs/aws-serverless-express/issues/58
    xhr.setRequestHeader('Authorization', `Bearer ${token}`);

    xhr.onload = function () {
      const arrayBufferView = new Uint8Array(this.response);
      const blob = new Blob([arrayBufferView], { type: 'image/png' });
      const urlCreator =  window.webkitURL;
      const imageUrl = urlCreator.createObjectURL(blob);
      tile.getImage().src = imageUrl;
    };
    xhr.send();
  };

  const footprintProperty = 'footprint_id';
  console.log("row x", row)
  const template = getTileUrlTemplate(
    row,
    row.stac_address, 
    row.collection_id,
    footprintProperty,
    row.min_date,
    row.max_date,
    row.date_display_resolution,
    "template",
  );
  if (!title) {
    title = getUniqueLayerTitle(map, row.title);
  }

  let crossover = zoomLevelCrossover;
  // Regarding crossover, max_zoom_level, and min_zoom_level -- max/min zoom levels  were added to syncarto_app > data_source table so as to be able to modify the max/min  resolutions on a per-layer basis. zoomLevelCrossover/zoomLevelCrossoverNaip are still used for Langlade/NAIP
  let maxRes = mapView.getResolutionForZoom(row.max_zoom_level);
  let minRes = mapView.getResolutionForZoom(row.min_zoom_level);
  if (row.collection_id === 'NAIP') {
    // another special case for naip; TODO set this dynamically based
    // on gsd of collection
    crossover = zoomLevelCrossoverNaip;
    maxRes = mapView.getResolutionForZoom(crossover);
    minRes = null;
  }

  let tileLayer;
  if (row.title && row.title.toLowerCase().includes('langlade')) {
    console.log('adding langlade mosaic');
    // temporary hack to get langlade zoomed out mosaic in until we can handle multiple resolutions
    // more generally
    tileLayer = new LayerGroup({
      layers: [
        new TileLayer({
          // this layer will start rendering at crossover+1
          maxResolution: mapView.getResolutionForZoom(crossover),
          source: new XYZ({
            url: template,
          }),
        }),
        new TileLayer({
          minResolution: mapView.getResolutionForZoom(crossover),
          source: new XYZ({
            url: 'https://tiles-{a-f}.syncarto.com/tiles/{z}/{x}/{y}?url=https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsyncarto-data-test%2Flanglade%2FLanglade_Co_2015_EastWest_PrintRes_COG.tif',
          }),
        }),
      ],
      title,
      extent: transformExtent(new Polygon(row.extent.coordinates).getExtent(), 'EPSG:4326', 'EPSG:3857'),
      yearStart: (new Date(row.min_date)).getUTCFullYear(), // year bounds of date range slider
      yearEnd: (new Date(row.max_date)).getUTCFullYear(),
      yearStartMin: (new Date(row.min_date)).getUTCFullYear(),
      yearEndMax: (new Date(row.max_date)).getUTCFullYear(),
      footprintProperty,
      dataSourceRow: row, // keep the raw data from the database row on the layer
    });
  } else {
    var _yearStart = 0; //row.min_date; //(new Date(row.min_date)).getUTCDate(); // year bounds of date range slider
    var _yearEnd = 0; //row.max_date; //(new Date(row.max_date)).getUTCDate();
    var _yearStartMin = 0;//row.min_date; //(new Date(row.min_date)).getUTCDate();
    var _yearEndMax = 0; //row.max_date; //(new Date(row.max_date)).getUTCDate();
    if (row.date_display_resolution === "year"){ // Grab just the year part of the date
      _yearStart = (new Date(row.min_date)).getUTCFullYear(); // year bounds of date range slider
      _yearEnd = (new Date(row.max_date)).getUTCFullYear();
      _yearStartMin = (new Date(row.min_date)).getUTCFullYear();
      _yearEndMax = (new Date(row.max_date)).getUTCFullYear();
    }
    if (row.date_display_resolution === "day"){ // Calculate the number of days from epoch with the date
      // e.g,  row.min_date --> "2020-06-20" --> 18433
      // e.g, row.max_date --> "2020-10-18" --> 18553
      var minDate:any = new Date(row.min_date);
      var maxDate:any = new Date(row.max_date);
      var minDaysSinceEpoch = Math.floor(minDate/8.64e7) - 1;
      var maxDaysSinceEpoch = Math.floor(maxDate/8.64e7) + 1;

      _yearStart = minDaysSinceEpoch; 
      _yearEnd = maxDaysSinceEpoch;
      _yearStartMin = minDaysSinceEpoch;
      _yearEndMax = maxDaysSinceEpoch;
    }
    console.log("row",row, template)
    tileLayer = new TileLayer({
      // this layer will start rendering at crossover+1
      maxResolution: maxRes, //mapView.getResolutionForZoom(crossover),
      minResolution: minRes,
      source: new XYZ({ // https://openlayers.org/en/v6.1.0/apidoc/module-ol_source_XYZ-XYZ.html
        url: template,
        attributions: row.citation, //'Tiles © <a href="https://landscan.ai/">LandScan</a>',
        //crossOrigin: 'anonymous',
        //crossOrigin: null,
      }),
      title,
      extent: transformExtent(new Polygon(row.extent.coordinates).getExtent(), 'EPSG:4326', 'EPSG:3857'),
      yearStart: _yearStart, //(new Date(row.min_date)).getUTCFullYear(), // year bounds of date range slider
      yearEnd: _yearEnd, //(new Date(row.max_date)).getUTCFullYear(),
      yearStartMin: _yearStartMin, //(new Date(row.min_date)).getUTCFullYear(),
      yearEndMax: _yearEndMax, //(new Date(row.max_date)).getUTCFullYear(),
      footprintProperty,
      dataSourceRow: row, // keep the raw data from the database row on the layer
      //preload:10, // Has caused 502 errors on zoom-levels 2,3,4,5 (even if beyond max/min). Needs research, see: https://openlayers.org/en/latest/apidoc/module-ol_layer_Tile-TileLayer.html
      //cacheSize: 128, //256, 
      //tileOptions: {crossOriginKeyword: null},
    });
  }
  
  // console.log('new TileLayer: ', tileLayer.get('yearStart'), tileLayer.get('yearEnd'));
  if (tileLayer.getSource) {
    tileLayer.getSource().setTileLoadFunction(tileLoadFunction);
  } else if (tileLayer.getLayers) {
    tileLayer.getLayers().forEach((layer: any) => {
      layer.getSource().setTileLoadFunction(tileLoadFunction);
    });
  }
  map.addLayer(tileLayer);
  return tileLayer;

}

//var aoiVectorLayer:any
//var dragBox:any 
//var dragBoxVectorLayer:any
//var displayFeatureOverlay:any
var addRemoveComponentLayerDW:any
function initGraphqlVectorLayers(apolloClient: any, map: any, _displayFeatureOverlay: any, socket: any, setWidgetTitleStatus: any, _aoiVectorLayer: any, _dragBox: any, _dragBoxVectorLayer: any) {
  setWidgetTitleStatus('loading data', async () => {
    // hopefully doing this in the setState callback will actually
    // make sure the title bar is updated before kicking off cpu-intensive task
    setWidgetTitleStatus('');

    // hack to get chart widget to re-send colorscale info once vector layers are initialized..
    // avoids race condition on page reload that causes map color scale to not get applied
    socket.emit('chart', { command: 'mapDoneLoadingVectorLayers' });
    //aoiVectorLayer = _aoiVectorLayer
    //dragBox = _dragBox
    //dragBoxVectorLayer = _dragBoxVectorLayer
    //displayFeatureOverlay = _displayFeatureOverlay
  });
}
function convertFromEpoch(daysFromEpoch:any){
  if (typeof daysFromEpoch === 'string') {
    return daysFromEpoch;
  }
  var valueFromEpoch = ((daysFromEpoch) * 8.64e7)
  var dateFromEpoch = new Date(valueFromEpoch);
  var ye = dateFromEpoch.toLocaleDateString("en-US", { year: 'numeric' });
  var mo = dateFromEpoch.toLocaleDateString("en-US", { month: 'numeric' });
  var da = dateFromEpoch.toLocaleDateString("en-US", { day: 'numeric' });
  if (mo.length < 2){
    mo = "0" + mo;
  }
  if (da.length < 2){
    da = "0" + da;
  }
  var dateFormatted = `${ye}-${mo}-${da}`;
  console.log("dateFormatted mapInit > convertFromEpoch", dateFormatted)
  return dateFormatted;
}
async function initMap(
    apolloClient: any, //1
    map: any, //2
    serverUrl: string, //3
    socket: SocketIOClient.Socket, //4
    el : HTMLElement, //5
    toggleMenuExpand: any, //6 
    handleLayerAddRemoveDataWarehouse: any, //7 
    addRemoveComponentLayer: any, //8
    setWidgetTitleStatus: any,  //9
    handleTileDownloadClick: any, //10
    updateAOIQuery: any, //11
    queryConnection: any, //12
    handleLayerAddRemoveService: any, //13
  ) {
  addRemoveComponentLayerDW = addRemoveComponentLayer;
  var app : any = {};
  const mapView = map.getView();

  initMeasureTool(app, map, el);
  var [aoiVectorLayer, selectedLayer, selectedParcelLayer, dragBoxVectorLayer, displayFeatureOverlay, dragBox, tileOutlinesLayer, /*tileOutlinesSource,*/ infoOverlay] = initOtherVectorLayers(map, el, socket, queryConnection);
  initMapSocketSync(socket, map, mapView, serverUrl, aoiVectorLayer, selectedLayer, selectedParcelLayer, tileOutlinesLayer, addRemoveComponentLayer,handleLayerAddRemoveDataWarehouse, updateAOIQuery, handleLayerAddRemoveService);
  initUseExtentButton(map, socket, aoiVectorLayer, app, updateAOIQuery);
  initTileDownloadButton(map, handleTileDownloadClick, tileOutlinesLayer, selectedLayer, selectedParcelLayer, infoOverlay, app);
  initMapPrintButton(map, app);
  initShipItButton(map, app, socket, aoiVectorLayer);
  initFarmBoundaries(socket, map, addRemoveComponentLayer);
  //initMenuExpand(app, toggleMenuExpand);

  map.addControl(new app.MeasureToolControl());
  //map.addControl(new app.MenuExpandControl());
  map.addControl(new app.UseExtentButton());
  map.addControl(new app.TileDownloadButton());
  map.addControl(new app.mapPrintButton());
  map.addControl(new app.shipItButton());

  // hack so map doesn't look stretched before first user resize
  map.updateSize();
  // these are cpu intensive so start them after other map init stuff is done
  initGraphqlVectorLayers(apolloClient, map, displayFeatureOverlay, socket, setWidgetTitleStatus, aoiVectorLayer, dragBox, dragBoxVectorLayer);
}


async function initDataWarehouseLayer(
  map: any, 
  _data: any,
  layerTitle: any,
  _dataQueryConfig: any,
  _dwdataLayerStyle: any,
  _dataChartType: any,
  layerToUpdate: any,
  query: any,
  layerType: any,
  layerCitation: string,
  layerVisibility: boolean,
    ) {
    await initGraphqlVectorLayer(
      _data, 
      map, 
      layerTitle,
      _dataQueryConfig,
      _dwdataLayerStyle,
      _dataChartType,
      layerToUpdate,
      query,
      layerType,
      layerCitation,
      layerVisibility
    );
  }

async function initServiceLayer(
  map: any,
  layerTitle: any,
  serviceConfig: any,
  layerStyle: any,
  chartType: any,
  layerToUpdate: any,
  layerVisibility:boolean
    ) {
    await initOLServiceLayer(
      map,
      layerTitle,
      serviceConfig,
      layerStyle,
      chartType,
      layerToUpdate,
      layerVisibility
    );
  }

export { initMap, createMapObject, getTileUrlTemplate, updateTileLayerDateRange, initDataWarehouseLayer, initServiceLayer };